(function() {
  var Backbone, Rubino, _,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  window.Rubino = {
    Collections: {},
    Models: {},
    Views: {},
    Routers: {},
    init: function() {
      this.cart = new Rubino.Models.Cart();
      this.cart_view = new Rubino.Views.CartPanel({
        model: this.cart
      });
      this.search_view = new Rubino.Views.Search();
      this.newsletter_view = new Rubino.Views.NewsletterPopUp();
      this.subscription_view = new Rubino.Views.SubscriptionPromo({
        el: $('[data-subscription-promo]')
      });
      this.views = [];
      this.render_views();
      this.initLazyLoader();
      this.bindEvents();
      this.quickViewModal();
      return this.customerinfo();
    },
    bindEvents: function() {
      this.mobileDetect();
      this.checkScroll();
      $(window).on("scroll", this.mobileDetect.bind(this));
      return $(window).on("scroll", this.checkScroll.bind(this));
    },
    checkScroll: function(e) {
      if (window.pageYOffset > 50) {
        if (!$('body').hasClass("scrolled")) {
          return $('body').addClass("scrolled");
        }
      } else {
        if ($('body').hasClass("scrolled")) {
          return $('body').removeClass("scrolled");
        }
      }
    },
    mobileDetect: function() {
      var diff;
      diff = iosInnerHeight() - window.innerHeight;
      return $('[data-mobile-detect]').each(function() {
        return $(this).css({
          'margin-bottom': diff
        });
      });
    },
    render_views: function() {
      var j, len, ref, view;
      ref = this.views;
      for (j = 0, len = ref.length; j < len; j++) {
        view = ref[j];
        view.undelegateEvents();
      }
      delete this.views;
      this.views = [];
      $("[data-promo]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Promo({
            el: element
          }));
        };
      })(this));
      $("[data-navigation]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Nav({
            el: element
          }));
        };
      })(this));
      $("[data-cart]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Cart({
            el: element,
            model: _this.cart
          }));
        };
      })(this));
      $("[data-sections]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Sections({
            el: element
          }));
        };
      })(this));
      $("[data-faq]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.FAQ({
            el: element
          }));
        };
      })(this));
      $("[data-accordions]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Accordions({
            el: element
          }));
        };
      })(this));
      $("[data-cart-total]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.CartTotal({
            el: element,
            model: _this.cart
          }));
        };
      })(this));
      $("[data-header]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Header({
            el: element
          }));
        };
      })(this));
      $("[data-filters]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Header({
            el: element
          }));
        };
      })(this));
      $("[data-newsletter]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Newsletter({
            el: element
          }));
        };
      })(this));
      $("[data-footer]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Footer({
            el: element
          }));
        };
      })(this));
      $("[data-hero]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Hero({
            el: element
          }));
        };
      })(this));
      $("[data-carousel]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Carousel({
            el: element
          }));
        };
      })(this));
      $("[data-footer]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Footer({
            el: element
          }));
        };
      })(this));
      $("[data-filters]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Filters({
            el: element
          }));
        };
      })(this));
      $("[data-slider]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Slider({
            el: element
          }));
        };
      })(this));
      $("[data-feed]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Feed({
            el: element
          }));
        };
      })(this));
      $("[data-map]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Map({
            el: element
          }));
        };
      })(this));
      $("[data-product-id]").each((function(_this) {
        return function(index, element) {
          if (element.hasAttribute("data-custom-size")) {
            return _this.views.push(new Rubino.Views.CustomProduct({
              el: element
            }));
          } else {
            return _this.views.push(new Rubino.Views.Product({
              el: element
            }));
          }
        };
      })(this));
      $("[data-collection-id]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Collection({
            el: element
          }));
        };
      })(this));
      $("[data-collection]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Collection2({
            el: element
          }));
        };
      })(this));
      $("[data-static-page]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.StaticPage({
            el: element
          }));
        };
      })(this));
      $("[data-fixed-nav]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.fixedNav({
            el: element
          }));
        };
      })(this));
      $("[data-form]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Form({
            el: element
          }));
        };
      })(this));
      $("[data-register]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Register({
            el: element
          }));
        };
      })(this));
      $("[data-related-products]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.Related({
            el: element
          }));
        };
      })(this));
      $(".newsletter--section-form").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.NewsletterSection({
            el: element
          }));
        };
      })(this));
      return $("[data-giftcard-form-wrapper]").each((function(_this) {
        return function(index, element) {
          return _this.views.push(new Rubino.Views.GiftCardForm({
            el: element
          }));
        };
      })(this));
    },
    initLazyLoader: function() {
      var self;
      self = this;
      setTimeout(function() {
        return self.verifyLoaded();
      }, 100);
      return document.addEventListener('lazybeforeunveil', function(t) {
        return self.lazyLoadBackground(t.target);
      });
    },
    verifyLoaded: function() {
      var self;
      self = this;
      return $(".lazyloaded").each(function() {
        return self.lazyLoadBackground(this);
      });
    },
    lazyLoadBackground: function(target) {
      var url;
      if ($(window).width() > 900) {
        url = target.getAttribute('data-bg-img');
      } else {
        url = target.getAttribute('data-bg-mobile-img');
      }
      if (url) {
        return target.style.backgroundImage = 'url(' + url + ')';
      }
    },
    quickViewModal: function() {
      $(document).on('click', '.quick-view', function(e) {
        var available, availableRaw, error1, id;
        e.stopImmediatePropagation();
        id = this.getAttribute('data-handle');
        console.log("availablity", {
          id: id
        });
        availableRaw = this.getAttribute('data-available');
        console.log("availablity", availableRaw);
        available = {};
        try {
          available = JSON.parse(availableRaw);
          console.log("availablity", available);
        } catch (error1) {
          e = error1;
          available = {};
          console.log(e);
        }
        $('.view-product').attr('href', '#');
        $('.ib_ptitle').text('');
        $('.ib_pvendor').text('');
        $(".ib_p_price .price .ib_vip_price").remove();
        $(".ib_p_price .price .ib_selling_price").remove();
        $(".ib_p_price .price .ib_compare_price").remove();
        $('.ibcat').text('');
        $('.ib_v_color > div').html('');
        $('.ib_sizes').html('');
        $('.ib_productcode').text('');
        $('.ib-product-img > img').attr('src', '');
        $('.product__thumbs').empty();
        $('.qv-add-button').attr('disabled', 'disabled');
        $('.qv-quantity').val('1');
        $('.ib_quick_modal').attr('id', id);
        $.getJSON('/products/' + id + '.js', function(product) {
          var calc_percent_discount, firstcolor, opt1arr, optarr, optsarr, original_price, p_featured_img, percent_discount, poptions, pprice, product_images, producttitle, ptags, pvariants, pvendor, url, vipEligible;
          producttitle = product.title;
          pvendor = product.vendor;
          pvariants = product.variants;
          poptions = product.options;
          ptags = product.tags;
          pprice = parseFloat(product.price / 100).toFixed(2);
          original_price = parseFloat(product.compare_at_price / 100).toFixed(2);
          percent_discount = Math.round(100 * (original_price - pprice) / original_price);
          calc_percent_discount = percent_discount.toFixed(2);
          product_images = product.media;
          p_featured_img = (product.variants[0] && product.variants[0].featured_image && product.variants[0].featured_image.src) || product.featured_image;
          vipEligible = window.loyalty.eligible.find(function(el) {
            return el === product.id;
          }) !== void 0;
          if (vipEligible != null) {
            $(".qv-add-button").attr("data-vip-eligible", "true");
          } else {
            $(".qv-add-button").removeAttr("data-vip-eligible");
          }
          url = '/products/' + id;
          if (window.Shopify.locale === "fr") {
            url = "/fr" + url;
          }
          if (pvariants[0]) {
            pprice = parseFloat(pvariants[0].price / 100).toFixed(2);
            original_price = parseFloat(pvariants[0].compare_at_price / 100).toFixed(2);
          }
          $('.view-product').attr('href', url);
          $('.view-product').click(function() {
            return window.location.href = url;
          });
          $('.ib_ptitle').text(producttitle);
          $('.ib_pvendor').text(pvendor);
          $('.ib_selling_price').text('$' + pprice);
          if ((window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.includes(product.id)) {
            $(".ib_p_price .price").append('<span class="ib_vip_price vip-price">$' + (pprice * (1 - window.loyalty.discount)).toFixed(2) + '</span>');
          }
          if (original_price > pprice) {
            $(".ib_p_price .price").append('<span class="ib_selling_price selling-price">$' + pprice + '</span>');
            $(".ib_p_price .price").append('<span class="ib_compare_price compare-price">$' + original_price + '</span>');
          } else {
            $(".ib_p_price .price").append('<span class="ib_compare_price compare-price">$' + pprice + '</span>');
          }
          $(ptags).each((function(_this) {
            return function(i, tag) {
              var category, splitTag;
              splitTag = tag.split(":");
              if (splitTag[0] === 'ca1') {
                category = splitTag[1];
                return $('.ibcat').text(category);
              }
            };
          })(this));
          optarr = [];
          optsarr = {};
          opt1arr = [];
          $(pvariants).each(function(i, v) {
            var pcolor, pimg, psize, v3, v_inv, v_qty;
            v_qty = v.available;
            v_inv = v.inventory_management;
            psize = v.option2;
            console.log("quickview", v);
            pimg = '';
            if (v.featured_image) {
              pimg = v.featured_image.src;
            }
            pcolor = v.option3;
            if (pcolor && !(indexOf.call(optarr, pcolor) >= 0)) {
              v3 = '<input type="radio" name="color" class="f_' + i + ' radio--color" value="' + pcolor + '" id="color_' + v.id + '"><label for="color_' + v.id + '" title="' + pcolor + '" data-color="' + pcolor + '" data-hover="' + v.id + '"><img class=" ls-is-cached lazyloaded" data-src="' + pimg + '" src="' + pimg + '"></label>';
              $('.ib_v_color > div').append(v3);
              return optarr.push(pcolor);
            }
          });
          firstcolor = optarr[0];
          $('.ib_sizes').empty();
          $(pvariants).each(function(i, v) {
            var disabled, pcolor, psize, v4, v_inv, v_qty;
            v_qty = v.available;
            v_inv = v.inventory_management;
            pcolor = v.option3;
            psize = v.option2;
            if (firstcolor === pcolor) {
              if (v_qty === false || !v.id || !available || available[v.id.toString()] !== true) {
                disabled = "disabled";
              } else {
                disabled = "";
              }
              v4 = '<input type="radio" name="size" ' + disabled + ' class="radio--box"  value="' + v.id + '" data-history="" id="size_' + v.id + '" data-size="' + psize + '" data-color="' + pcolor + '" data-qty=""><label class=" " for="size_' + v.id + '">' + psize + '</label>';
              return $('.ib_sizes').append(v4);
            }
          });
          $(ptags).each((function(_this) {
            return function(i, tag) {
              var model, splitTag;
              splitTag = tag.split(":");
              if (splitTag[0] === firstcolor) {
                model = splitTag[1];
                return $('.ib_productcode').text(model);
              }
            };
          })(this));
          window.pid = product.id;
          window.variants = pvariants;
          window.pimages = product_images;
          window.ptags = ptags;
          if (p_featured_img) {
            $('.ib-product-img > img').attr('src', p_featured_img);
          }
          $('.product__thumbs').empty();
          $('.ib_quick_modal').show();
          $('.ib_quick_modal > #contentdiv').scrollTop(0);
          Rubino.helpers.enableBodyBlock();
          $(product_images).each(function(i, image) {
            var iarr, image_embed;
            iarr = image && image.alt && image.alt.split(":");
            if (!iarr || (iarr.length >= 2 && iarr[0] === "VARIANT" && iarr[1] === firstcolor)) {
              image_embed = '<div class="normal_gap"><img class=" lazyloaded" src="' + image.src + '"></div>';
              image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
              return $('.product__thumbs').append(image_embed);
            }
          });
          return $(".ib_v_color label").first().trigger("click");
        });
        $(document).on('click', '.ib_v_color label', function() {
          var active_variant, calc_percent_discount, cid, firstcolor, original_price, p_featured_img, percent_discount, pid, pprice, product_images, ptags, pvariants;
          $(".ib_p_price .price .ib_vip_price").remove();
          $(".ib_p_price .price .ib_selling_price").remove();
          $(".ib_p_price .price .ib_compare_price").remove();
          $('input[name="color"]').removeAttr('checked');
          cid = $(this).attr('for');
          $('#' + cid).attr('checked', 'checked');
          pid = window.pid;
          pvariants = window.variants;
          active_variant = pvariants.find(function(v) {
            return v.id.toString() === cid.split('_')[1];
          });
          pprice = parseFloat(active_variant.price / 100).toFixed(2);
          original_price = parseFloat(active_variant.compare_at_price / 100).toFixed(2);
          percent_discount = Math.round(100 * (original_price - pprice) / original_price);
          calc_percent_discount = percent_discount.toFixed(2);
          if ((window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.includes(pid)) {
            $(".ib_p_price .price").append('<span class="ib_vip_price vip-price">$' + (pprice * (1 - window.loyalty.discount)).toFixed(2) + '</span>');
          }
          if (original_price > pprice) {
            $(".ib_p_price .price").append('<span class="ib_selling_price selling-price">$' + pprice + '</span>');
            $(".ib_p_price .price").append('<span class="ib_compare_price compare-price">$' + original_price + '</span>');
          } else {
            $(".ib_p_price .price").append('<span class="ib_compare_price compare-price">$' + pprice + '</span>');
          }
          product_images = window.pimages;
          ptags = window.ptags;
          firstcolor = $(this).data('color');
          p_featured_img = '';
          $('.ib_sizes').empty();
          $('.qv-add-button').attr('disabled', 'disabled');
          $(pvariants).each(function(i, v) {
            var disabled, pcolor, psize, v4, v_inv, v_qty;
            console.log("quickview2", v);
            v_qty = v.available;
            v_inv = v.inventory_management;
            pcolor = v.option3;
            psize = v.option2;
            if (firstcolor === pcolor) {
              if (v_qty === false) {
                disabled = "disabled";
              } else {
                disabled = "";
              }
              v4 = '<input type="radio" name="size" ' + disabled + ' class="radio--box"  value="' + v.id + '" data-history="" id="size_' + v.id + '" data-size="' + psize + '" data-color="' + pcolor + '" data-qty=""><label class=" " for="size_' + v.id + '">' + psize + '</label>';
              return $('.ib_sizes').append(v4);
            }
          });
          $(ptags).each((function(_this) {
            return function(i, tag) {
              var model, splitTag;
              splitTag = tag.split(":");
              if (splitTag[0] === firstcolor) {
                model = splitTag[1];
                return $('.ib_productcode').text(model);
              }
            };
          })(this));
          $('.product__thumbs').empty();
          $(product_images).each(function(i, image) {
            var iarr, image_embed;
            iarr = image.alt.split(":");
            if (iarr[0] === "VARIANT" && iarr[1] === firstcolor) {
              image_embed = '<div class="normal_gap"><img class=" lazyloaded" src="' + image.src + '"></div>';
              image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
              $('.product__thumbs').append(image_embed);
              if (p_featured_img === "") {
                return p_featured_img = image.src;
              }
            }
          });
          return $('.ib-product-img > img').attr('src', p_featured_img);
        });
        $(document).on('click', '.ib-product-thumb img', function() {
          var isrc;
          isrc = $(this).attr("src");
          return $('.ib-product-img > img').attr('src', isrc);
        });
        $(document).on('click', '.ib_v_color input[type=radio]', function() {
          return $(this).attr('checked', 'checked');
        });
        setTimeout(function() {
          var radios;
          radios = $('.ib_v_color input[name="color"]');
          if (radios.is(':checked') === false) {
            return $('.ib_v_color input.f_0').click();
          }
        }, 2000);
        $(document).on('click', '.ib_sizes label', function() {
          var allinpts, inpt, vid;
          allinpts = $(this).parent().find('input[type="radio"]');
          allinpts.removeAttr('checked');
          inpt = $(this).prev("input");
          inpt.attr('checked', 'checked');
          $('.qv-add-button').removeAttr("disabled");
          vid = inpt.val();
          return $('.qv-add-button').attr('data-add-to-cart', vid);
        });
        $('.qv-quantity').empty();
        return $(document).on('click', 'div[data-product-increment]', function(e) {
          var increment, newQty, oldqty, qty;
          e.preventDefault();
          e.stopImmediatePropagation();
          oldqty = $(this).parent('.product__qty').find('.qv-quantity');
          qty = parseInt(oldqty.val());
          increment = $(this).data('product-increment');
          newQty = qty + increment;
          if (newQty < 1) {
            newQty = 1;
          }
          return $(this).parent('.product__qty').find('.qv-quantity').val(newQty);
        });
      });
      $('.qv-add-button').click(function(e) {
        var data, qty;
        e.preventDefault();
        Rubino.helpers.disableBodyBlock();
        $('.ib_quick_modal').hide();
        qty = $('.qv-quantity').val();
        data = {};
        if ($(e.currentTarget).data('vipEligible') != null) {
          data['properties'] = data['properties'] || {};
          data['properties']["_vip_eligible"] = true;
          console.log("I'm eligible!");
        }
        Rubino.cart.add($(e.currentTarget).attr("data-add-to-cart"), qty || 1, data);
      });
      $(document).on('click', '.ib_modal_window.ib_quick_modal', function(e) {
        e.preventDefault();
        if (e.target !== this) {
          return;
        }
        $('.ib_v_color > div').empty();
        $('.product__thumbs').empty();
        $('.ib_sizes > div').empty();
        Rubino.helpers.disableBodyBlock();
        $('.ib_quick_modal').hide();
        $('.qv-add-button').attr('disabled', 'disabled');
        return $('.qv-quantity').val(1);
      });
      $(".quick-view").each(function(index, element) {
        var handle;
        return handle = this.getAttribute('data-handle');
      });
      return $('.ib_close').click(function() {
        $('.ib_v_color > div').empty();
        $('.product__thumbs').empty();
        $('.ib_sizes > div').empty();
        Rubino.helpers.disableBodyBlock();
        $('.ib_quick_modal').hide();
        $('.div[data-product-increment]').hide();
        return $('.qv-add-button').attr('disabled', 'disabled');
      });
    },
    customerinfo: function() {
      var tabInterval, tabIntervalCounter;
      $(document).on('click', '.ib-next, .ib-order-next', function(e) {
        var nexturl;
        localStorage.removeItem("prevurl");
        nexturl = this.getAttribute('href');
        return localStorage.setItem('nexturl', nexturl);
      });
      $(document).on('click', '.ib-pre, .ib-order-pre', function(e) {
        var prevurl;
        localStorage.removeItem("nexturl");
        prevurl = this.getAttribute('href');
        return localStorage.setItem('prevurl', prevurl);
      });
      $(document).on('click', '.edit_cancel, #add_cancel', function(e) {
        var addresses;
        addresses = $('.edit_address');
        addresses.addClass('hide');
        return $('html, body').animate({
          scrollTop: $('#scroll_test').offset().top + (-200)
        }, 1000);
      });
      $(document).on('click', '#add_cancel', function(e) {
        return $('#add_address').addClass('hide');
      });
      $(document).on('click', '.order_link', function(e) {
        return $('.order_table').addClass('hide');
      });
      $(document).on('click', '#ib_return', function(e) {
        $('.order_table').removeClass('hide');
        return $('.ib_o_view').addClass('hide');
      });
      $(document).on('click', '.faq__nav.ib-nav ul li a[data-toggle-section]', function(e) {
        var section, url_string;
        section = e.target.dataset.toggleSection;
        if (window.Shopify.locale === "fr") {
          return window.history.pushState(null, null, "/fr/account/?tab=" + section);
        } else {
          window.history.pushState(null, null, "/account/?tab=" + section);
          return url_string = window.location.href;
        }
      });
      $(document).on('keyup', '#password_confirm, #password_new', function(e) {
        var conp, cp, np;
        cp = $("#password").val();
        np = $("#password_new").val();
        conp = $("#password_confirm").val();
        if (np !== conp) {
          $('#error').html('Error: Password not matched');
          $('#save_pass').attr('disabled', 'disabled');
          return $('#success').empty();
        } else {
          $('#error').empty();
          $('#save_pass').removeAttr('disabled', 'disabled');
          return $('#success').html('Success: Password matched');
        }
      });
      $(document).on('click', '#save_pass', function(e) {
        var basicauth, confirm_ps, current_ps, email, hash, new_ps, tok;
        e.stopImmediatePropagation();
        current_ps = $("#password").val();
        new_ps = $("#password_new").val();
        confirm_ps = $("#password_confirm").val();
        email = $("#c_email").val();
        tok = email + ':' + current_ps;
        hash = btoa(tok);
        basicauth = "Basic " + hash;
        if (current_ps === '' || new_ps === '' || confirm_ps === '') {
          return $('.ib_info_fields input').each(function() {
            if ($(this).val() === '') {
              $('#save_passsuccess').empty('');
              $('#save_passerror').html('Error: Please fill all fields!');
            }
          });
        } else {
          $('#save_pass').attr('disabled', 'disabled');
          return $.ajax({
            url: 'https://us-central1-rubino-shoes.cloudfunctions.net/customer_update',
            type: 'POST',
            dataType: 'json',
            async: true,
            data: {
              "password": new_ps
            },
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', basicauth);
            },
            success: function(data) {
              $('#save_passsuccess').html('Password Updated Successfully!');
              $('#save_pass').removeAttr('disabled', 'disabled');
              setTimeout(function() {
                if (window.Shopify.locale === "fr") {
                  return window.location.href = '/fr/account/?tab=mot-de-passe';
                } else {
                  return window.location.href = '/account/?tab=edit-password';
                }
              }, 3000);
            },
            error: function(error) {
              $('#save_pass').removeAttr('disabled');
              return $('#save_passerror').html('Error: Password is incorrect.');
            }
          });
        }
      });
      $(document).on("click", '#customer_data', function(e) {
        var accepts_marketing_pref, basicauth, ce, cp, dobd, dobm, doby, fn, hash, lang, lang_pref, ln, po, prefs, tok;
        e.stopImmediatePropagation();
        po = false;
        fn = $('#first-name').val();
        ln = $('#last-name').val();
        cp = $('#c_password').val();
        ce = $('#c_email').val();
        lang = $('#accountlang').val();
        doby = $('[name="birthday_y"]').val();
        dobm = $('[name="birthday_m"]').val();
        dobd = $('[name="birthday_d"]').val();
        lang_pref = $("input[name='lang_pref']:checked").val();
        accepts_marketing_pref = $('[name="accepts_marketing_pref"]:checked').val();
        prefs = [];
        $('[name="shopping_prefs[]"]').each(function() {
          if ($(this).prop('checked')) {
            return prefs.push($(this).val());
          }
        });
        if (accepts_marketing_pref === "true") {
          po = true;
        } else {
          po = false;
        }
        tok = ce + ':' + cp;
        hash = btoa(tok);
        basicauth = "Basic " + hash;
        if (cp === '' || fn === '' || ln === '') {
          return $('.ib_info_data input').each(function() {
            if ($(this).val() === '') {
              $('#success').empty();
              $('#error').html('Error: Please fill all fields!');
            }
          });
        } else {
          $('#error').html();
          $('#customer_data').attr('disabled', 'disabled');
          return $.ajax({
            url: 'https://us-central1-rubino-shoes.cloudfunctions.net/customer_update',
            type: 'POST',
            dataType: 'json',
            async: true,
            data: {
              "firstName": fn,
              "lastName": ln
            },
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', basicauth);
            },
            success: function(data) {
              $('#success').html(window.Shopify.locale === {
                "fr": {
                  "Informations mis à jour": 'Data Updated.'
                }
              });
              $('#customer_data').removeAttr('disabled', 'disabled');
              return Rubino.contact.createOrUpdate(ce, fn, ln, lang_pref, po, doby, dobm, dobd, prefs.join(",")).done(function() {
                if (window.Shopify.locale === "fr") {
                  window.location.href = '/fr/account/?tab=renseignements-personnels';
                } else {
                  window.location.href = '/account/?tab=personal-information';
                }
              });
            },
            error: function(error) {
              $('#customer_data').removeAttr('disabled');
              return $('#error').html(window.Shopify.locale === {
                "fr": {
                  "Une erreur est survenu. Veuillez verifier votre mot de passe et ressayer": 'An error has occured. Please check your password and try again.'
                }
              });
            }
          });
        }
      });
      $(document).on("click", 'a[data-member-cancel]', function(e) {
        return $("[data-member-cancel-confirm-wrapper]").show();
      });
      $(document).on("click", 'a[data-member-cancel-cancel]', function(e) {
        return $("[data-member-cancel-confirm-wrapper]").hide();
      });
      $(document).on("click", 'a[data-member-cancel-confirm]', function(e) {
        var contract_id;
        contract_id = e.currentTarget.dataset.memberCancelConfirm;
        return $.ajax({
          url: '/apps/wc8-rubino/cancel',
          type: "POST",
          dataType: "json",
          data: {
            "contract_id": contract_id,
            "shopurl": window.Shopify.shop
          },
          cache: false,
          success: function() {
            return window.location.reload();
          },
          error: function(data) {
            return console.error("error", data);
          }
        });
      });
      $(document).on("click", 'a[data-member-update-payment]', function(e) {
        var paymentMethodId;
        paymentMethodId = e.currentTarget.dataset.memberUpdatePayment;
        return $.ajax({
          url: '/apps/wc8-rubino/update?payment_method_id=' + paymentMethodId + '&shopurl=' + window.Shopify.shop,
          type: "GET",
          cache: false,
          success: function(data) {
            return window.location.href = data.updatePaymentMethodUrl;
          },
          error: function(data) {
            return console.error("error", data);
          }
        });
      });
      $(document).ready(function(e) {
        return $(window).on('popstate', function(e) {
          return location.reload(true);
        });
      });
      $(document).on("click", '.order_link', function(e) {
        var loaderhtml, nexturlredirect, onum, order_id, prevurlredirect, url;
        e.stopImmediatePropagation();
        loaderhtml = '<div class="ibbox"><div class="ibcontainer"><span class="ibcircle"></span><span class="ibcircle"></span><span class="ibcircle"></span><span class="ibcircle"></span></div></div>';
        $('#account_view_order').html('');
        $('#account_view_order').html(loaderhtml);
        url = this.getAttribute('data-order-link');
        order_id = this.getAttribute('data-order-id');
        onum = order_id.replace('#', '');
        nexturlredirect = localStorage.getItem('nexturl');
        prevurlredirect = localStorage.getItem('prevurl');
        if (nexturlredirect !== null) {
          window.history.pushState(null, null, nexturlredirect);
        } else if (prevurlredirect !== null) {
          window.history.pushState(null, null, prevurlredirect);
        } else {
          if (window.Shopify.locale === "fr") {
            window.history.pushState(null, null, "/fr/account/?tab=commandes");
          } else {
            window.history.pushState(null, null, "/account/?tab=orders");
          }
        }
        window.history.pushState(null, null, url);
        return $.ajax({
          url: url,
          type: 'GET',
          cache: false,
          success: function(data) {
            return $('#account_view_order').html($(data).find('#order_view').html());
          }
        });
      });
      $(document).on("click", ".ib_back_order", function(e) {
        var nexturlredirect, prevurlredirect;
        e.preventDefault();
        nexturlredirect = localStorage.getItem('nexturl');
        prevurlredirect = localStorage.getItem('prevurl');
        if (nexturlredirect !== null) {
          return window.location.href = nexturlredirect;
        } else if (prevurlredirect !== null) {
          return window.location.href = prevurlredirect;
        } else {
          if (window.Shopify.locale === "fr") {
            return window.location.href = "/fr/account/?tab=commandes";
          } else {
            return window.location.href = "/account/?tab=orders";
          }
        }
      });
      tabIntervalCounter = 0;
      return tabInterval = setInterval(function() {
        var c, searchTab, url, url_string;
        url_string = window.location.href;
        url = new URL(url_string);
        c = url.searchParams.get("tab");
        searchTab = document.querySelector('a[data-toggle-section="' + c + '"]');
        if (searchTab) {
          clearInterval(tabInterval);
          $(searchTab).trigger('click');
          window.history.pushState(null, null, url_string);
        } else if (tabIntervalCounter > 10) {
          clearInterval(tabInterval);
        }
        return tabIntervalCounter++;
      }, 100);
    }
  };

  Rubino = window.Rubino;

  _ = window._;

  Backbone = window.Backbone;

  $(function() {
    return Rubino.init();
  });

}).call(this);

(function() {
  Rubino.contact = {
    verifyRegistration: function(email, firstname, lastname, lang, subscribe) {
      if (firstname == null) {
        firstname = null;
      }
      if (lastname == null) {
        lastname = null;
      }
      if (lang == null) {
        lang = 'en';
      }
      if (subscribe == null) {
        subscribe = false;
      }
      if (window.localStorage.getItem('form-submit') === 'register') {
        this.createOrUpdate(email, firstname, lastname, lang, subscribe);
        return window.localStorage.setItem('form-submit', null);
      }
    },
    createOrUpdate: function(email, firstname, lastname, lang, subscribe, dob_y, dob_m, dob_d, shopping_prefs) {
      var data, langCode, subscribeCode;
      if (lang == null) {
        lang = 'en';
      }
      if (subscribe == null) {
        subscribe = false;
      }
      data = {};
      data['email'] = email;
      if (firstname) {
        data['first'] = firstname;
      }
      if (lastname) {
        data['last'] = lastname;
      }
      if (dob_y) {
        data['birthday_y'] = dob_y;
      }
      if (dob_m) {
        data['birthday_m'] = dob_m;
      }
      if (dob_d) {
        data['birthday_d'] = dob_d;
      }
      if (shopping_prefs) {
        data['shopping_prefs'] = shopping_prefs;
      }
      if (lang === 'en') {
        langCode = 1;
      } else if (lang === 'fr') {
        langCode = 2;
      }
      if (subscribe) {
        subscribeCode = 1;
      } else {
        subscribeCode = 2;
      }
      data['lang'] = langCode;
      return data['subscribe'] = subscribeCode;
    }
  };

}).call(this);

(function() {
  Rubino.cookies = {
    set: function(name, value, expiry_days) {
      var d, expires;
      d = new Date();
      d.setTime(d.getTime() + (expiry_days * 24 * 60 * 60 * 1000));
      expires = "expires=" + d.toGMTString();
      return document.cookie = "X-" + name + "=" + value + "; " + expires + "; path=/";
    },
    set_for_a_session: function(name, value) {
      return document.cookie = "X-" + name + "=" + value + "; path=/";
    },
    get: function(name) {
      var cookie, cookies, fn, i, len, value;
      name = "X-" + name + "=";
      value = false;
      cookies = document.cookie.split(';');
      fn = function(cookie) {
        cookie = cookie.trim();
        if (cookie.indexOf(name) === 0) {
          return value = cookie.substring(name.length, cookie.length);
        }
      };
      for (i = 0, len = cookies.length; i < len; i++) {
        cookie = cookies[i];
        fn(cookie);
      }
      if (!value) {
        value = null;
      }
      return value;
    },
    "delete": function(name) {
      return document.cookie = 'X-' + name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
  };

}).call(this);

(function() {
  Rubino.helpers = {
    get_query_string: function() {
      var m, query_string, regex, result;
      result = {};
      query_string = location.search.slice(1);
      regex = /([^&=]+)=([^&]*)/g;
      m = null;
      while ((m = regex.exec(query_string))) {
        result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
      }
      return result;
    },
    touchMoveBlocker: function(e) {
      if (e.target.tagName.toLowerCase() === 'body') {
        e.preventDefault();
      }
    },
    enableBodyBlock: function() {
      var scrollPosition;
      document.body.addEventListener('touchmove', this.touchMoveBlocker, {
        passive: false
      });
      document.body.addEventListener('scroll', this.touchMoveBlocker, {
        passive: false
      });
      document.body.addEventListener('wheel', this.touchMoveBlocker, {
        passive: false
      });
      scrollPosition = [self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft, self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop];
      $('html').data('scroll-position', scrollPosition);
      $('html').addClass("noscroll");
      return window.scrollTo(scrollPosition[0], scrollPosition[1]);
    },
    disableBodyBlock: function() {
      var scrollPosition;
      document.body.removeEventListener('touchmove', this.touchMoveBlocker);
      document.body.removeEventListener('scroll', this.touchMoveBlocker);
      document.body.removeEventListener('wheel', this.touchMoveBlocker);
      $('html, body').removeClass("noscroll");
      scrollPosition = $('html').data('scroll-position');
      $('html').css('overflow', $('html').data('previous-overflow'));
      return window.scrollTo(scrollPosition[0], scrollPosition[1]);
    }
  };

}).call(this);

(function() {
  var rubinoDiscount, rubinoDiscount_fr;

  rubinoDiscount = "RUBINO MEMBER";

  rubinoDiscount_fr = "MEMBRE RUBINO";

  Handlebars.registerHelper('final', function(id, options) {
    var final;
    if (localStorage.getItem('final')) {
      final = JSON.parse(localStorage.getItem('final'));
      if (final.includes(id.toString())) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('finalText', function(id, options) {
    var final;
    if (window.cart_text.enable_final_text && localStorage.getItem('final')) {
      final = JSON.parse(localStorage.getItem('final'));
      if (final.includes(id.toString())) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('money', function(value) {
    if (value != null) {
      return "$" + (parseFloat(value) / 100).toFixed(2) + " " + window.currency;
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('moneyFix', function(value) {
    if (value != null) {
      return "$" + (parseFloat(value)).toFixed(2) + " " + window.currency;
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('moneyPlus', function(value, plus) {
    if (value != null) {
      return "$" + ((parseFloat(value) / 100) + plus).toFixed(2) + " " + window.currency;
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('percentage', function(high, low) {
    var discount, percent;
    discount = high - low;
    percent = (discount / high) * 100;
    return '-' + Math.round(percent) + '%';
  });

  Handlebars.registerHelper('isFinalSale', function(value, options) {
    var price;
    price = (parseFloat(value) / 100).toFixed(2) + '';
    if (price.endsWith("00")) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('priceDiff', function(price, diff) {
    price = parseFloat(price) / 100;
    return (diff - price).toFixed(2);
  });

  Handlebars.registerHelper('thumbnail', function(image) {
    return image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
  });

  Handlebars.registerHelper('replace', function(string, sub1, sub2) {
    return string.replace(sub1, sub2);
  });

  Handlebars.registerHelper('truncate', function(string, end) {
    if (string != null) {
      string = string.slice(0, end);
      if (string.length >= end) {
        string += "...";
      }
      return string;
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('first', function(models, options) {
    if ((models != null) && (models[0] != null)) {
      return options.fn(models[0]);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('last', function(models, options) {
    if ((models != null) && (models[models.length - 1] != null)) {
      return options.fn(models[models.length - 1]);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('get', function(model, key) {
    if ((model != null) && (model[key] != null)) {
      return model[key];
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('if_get', function(model, key, options) {
    if ((model[key] != null) && model[key]) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('unless_get', function(model, key, options) {
    if ((model[key] != null) && model[key]) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('if_equal', function(left, right, options) {
    debugger;
    if (left === right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_lower', function(left, right, options) {
    if (left < right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_price_higher', function(left, right, options) {
    if ((left / 100) >= right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_price_lower', function(left, right, options) {
    if ((left / 100) < right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_higher', function(left, right, options) {
    if (left > right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_higher_vip', function(left, right, discounts, options) {
    var vipDiscount;
    vipDiscount = discounts.find(function(discount) {
      return discount.title === rubinoDiscount || discount.title === rubinoDiscount_fr;
    });
    if (vipDiscount != null) {
      if (left > right + vipDiscount.amount) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    } else {
      if (left > right) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    }
  });

  Handlebars.registerHelper('money_without_vip', function(value, discounts) {
    var vipDiscount;
    vipDiscount = discounts.find(function(discount) {
      return discount.title === rubinoDiscount || discount.title === rubinoDiscount_fr;
    });
    if (vipDiscount != null) {
      if (value != null) {
        return "$" + (parseFloat(value + vipDiscount.amount) / 100).toFixed(2) + " " + window.currency;
      } else {
        return null;
      }
    } else {
      if (value != null) {
        return "$" + (parseFloat(value) / 100).toFixed(2) + " " + window.currency;
      } else {
        return null;
      }
    }
  });

  Handlebars.registerHelper('percentage_without_vip', function(high, low, discounts) {
    var highPrice, percentage, salePrice, vipDiscount;
    vipDiscount = discounts.find(function(discount) {
      return discount.title === rubinoDiscount || discount.title === rubinoDiscount_fr;
    });
    if (vipDiscount != null) {
      salePrice = low;
      highPrice = high - vipDiscount.amount;
      percentage = ((highPrice - salePrice) / highPrice) * 100;
      console.log({
        discounts: discounts,
        high: high,
        highPrice: highPrice,
        low: low,
        salePrice: salePrice,
        percentage: percentage
      });
      return '-' + Math.round(percentage) + '%';
    } else {
      percentage = ((high - low) / high) * 100;
      return '-' + Math.round(percentage) + '%';
    }
  });

  Handlebars.registerHelper('if_get_equal', function(model, key, right, options) {
    if ((model[key] != null) && model[key] === right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('unless_equal', function(left, right, options) {
    if (left !== right) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_in_array', function(array, right, options) {
    if ((array != null) && _.contains(array, right)) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('date', function(date) {
    var newDate, timestamp;
    timestamp = parseInt(date) * 1000;
    newDate = new Date(timestamp);
    return newDate.toLocaleDateString();
  });

  Handlebars.registerHelper('dateDiff', function(date) {
    var newDate, timestamp;
    timestamp = parseInt(date) * 1000;
    newDate = new Date(timestamp);
    return moment(newDate).fromNow();
  });

  Handlebars.registerHelper('if_dates_equal', function(left, right, options) {
    left = new Date(left);
    right = new Date(right);
    if (left.toLocaleDateString() === right.toLocaleDateString()) {
      return options.fn(this);
    } else {
      return null;
    }
  });

  Handlebars.registerHelper('json', function(json) {
    return JSON.stringify(JSON.parse(json), void 0, 2);
  });

  Handlebars.registerHelper('address', function(address) {
    var address_text;
    address_text = "";
    if (address != null) {
      if (address.name != null) {
        address.first_name = address.name;
        address.last_name = "";
      }
      address_text += address.first_name + " " + address.last_name + "<br>" + address.street;
      if ((address.street_continued != null) && address.street_continued !== "") {
        address_text += address.street_continued;
      }
      address_text += " " + address.city + ", " + address.region + ", " + address.country + " " + address.zip;
    }
    return address_text;
  });

  Handlebars.registerHelper('ms', function(value) {
    return (parseFloat(value)).toFixed(3) + "ms";
  });

  Handlebars.registerHelper('plus', function(left, right) {
    return left + right;
  });

  Handlebars.registerHelper('minus', function(left, right) {
    return left - right;
  });

  Handlebars.registerHelper('times', function(value, times) {
    return value * times;
  });

  Handlebars.registerHelper('divide', function(left, right) {
    return left / right;
  });

  Handlebars.registerHelper('encode_uri', function(url) {
    return encodeURIComponent(url);
  });

  Handlebars.registerHelper('first_letter', function(string) {
    if (string != null) {
      return string[0].toUpperCase();
    }
  });

  Handlebars.registerHelper('first_word', function(string) {
    var firstWord, firstWordPosition, rest;
    firstWordPosition = string.indexOf(" ");
    firstWord = string.substr(0, firstWordPosition);
    rest = string.substr(firstWordPosition + 1);
    string = firstWord + ' <span>' + rest + '</span>';
    return string;
  });

  Handlebars.registerHelper('name_from_email', function(email) {
    if (email != null) {
      return email.split("@")[0];
    }
  });

  Handlebars.registerHelper('first_name_from_name', function(name) {
    if (name != null) {
      return name.split(" ")[0];
    }
  });

  Handlebars.registerHelper("if_is_vip", function(options) {
    if (window.loyalty.isVIP || window.loyalty.isCartVIP) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('if_vip_eligible', function(id, options) {
    if ((id != null) && window.loyalty.eligible.indexOf(id) > -1 && (window.loyalty.isVIP || window.loyalty.isCartVIP)) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('vip_money', function(value, discounts) {
    var discountTotal, otherDiscounts, vipDiscount;
    otherDiscounts = discounts.filter(function(discount) {
      return discount.title !== rubinoDiscount && discount.title !== rubinoDiscount_fr;
    });
    discountTotal = 0;
    otherDiscounts.forEach(function(discount) {
      return discountTotal += discount.amount;
    });
    vipDiscount = discounts.find(function(discount) {
      return discount.title === rubinoDiscount || discount.title === rubinoDiscount_fr;
    });
    if (vipDiscount != null) {
      if (value != null) {
        return "$" + (parseFloat(value + discountTotal) / 100).toFixed(2) + " " + window.currency;
      } else {
        return null;
      }
    } else {
      if (value != null) {
        return "$" + (parseFloat(value * (1 - window.loyalty.discount)) / 100).toFixed(2) + " " + window.currency;
      } else {
        return null;
      }
    }
  });

  Handlebars.registerHelper('vip_percentage', function(high, low, discounts) {
    var discount, percent, vipDiscount;
    vipDiscount = discounts.find(function(discount) {
      return discount.title === rubinoDiscount || discount.title === rubinoDiscount_fr;
    });
    if (vipDiscount != null) {
      discount = vipDiscount.amount;
      percent = (discount / high) * 100;
      return '-' + Math.round(percent) + '%';
    } else {
      discount = high - (low * (1 - window.loyalty.discount));
      percent = (discount / high) * 100;
      return '-' + Math.round(percent) + '%';
    }
  });

  Handlebars.registerHelper('vip_total', function(items) {
    var i, item, len, total, vipDiscount;
    total = 0;
    for (i = 0, len = items.length; i < len; i++) {
      item = items[i];
      vipDiscount = item.discounts.find(function(discount) {
        return discount.title === rubinoDiscount || discount.title === rubinoDiscount_fr;
      });
      if (!vipDiscount && (window.loyalty.isVIP || window.loyalty.isCartVIP) && window.loyalty.eligible.indexOf(item.product_id) > -1) {
        total += item.final_price * (1 - window.loyalty.discount) * item.quantity;
      } else {
        total += item.final_price * item.quantity;
      }
    }
    return "$" + (parseFloat(total) / 100).toFixed(2) + " " + window.currency;
  });

  Handlebars.registerHelper('if_not_loyalty', function(id, options) {
    if (id.toString() !== window.loyalty.productId.toString()) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Models.Cart = (function(superClass) {
    extend(Cart, superClass);

    function Cart() {
      return Cart.__super__.constructor.apply(this, arguments);
    }

    Cart.prototype.url = "/cart?view=compare";

    Cart.prototype.parse = function(response) {
      return response;
    };

    Cart.prototype.initialize = function() {
      var isCartVIP;
      $.ajax("/cart.js", {
        method: "GET",
        dataType: "json",
        success: (function(_this) {
          return function(response) {
            if (response) {
              if (!response.items.find((function(item) {
                return item.product_id === window.loyalty.productId;
              }))) {
                $(".subscription_add_button").prop("disabled", false);
                if (!window.loyalty.isVIP) {
                  $(".header--main__top").removeClass("vip_header");
                  $(".header--main__top .vip_message").addClass("not_member").attr("href", window.loyalty.texts.notVIPUrl).text(window.loyalty.texts.notVIPmessage);
                  $(".vip-price").remove();
                  $(".vip-section").remove();
                }
                window.loyalty.isCartVIP = false;
                return window.sessionStorage.removeItem("isCartVIP");
              } else {
                $(".subscription_add_button").prop("disabled", true);
                $(".header--main__top").addClass("vip_header");
                $(".header--main__top .vip_message").removeClass("not_member").attr("href", window.loyalty.texts.VIPUrl).text(window.loyalty.texts.VIPmessage);
                window.loyalty.isCartVIP = true;
                return window.sessionStorage.setItem("isCartVIP", true);
              }
            }
          };
        })(this)
      });
      isCartVIP = window.sessionStorage.getItem("isCartVIP");
      if (!!isCartVIP || window.loyalty.isVIP || window.loyalty.isVIPCart) {
        $(".header--main__top").addClass("vip_header");
        $(".header--main__top .vip_message").removeClass("not_member").attr("href", window.loyalty.texts.VIPUrl).text(window.loyalty.texts.VIPmessage);
      } else {
        $(".header--main__top").removeClass("vip_header");
        $(".header--main__top .vip_message").addClass("not_member").attr("href", window.loyalty.texts.notVIPUrl).text(window.loyalty.texts.notVIPmessage);
      }
      return this.fetch();
    };

    Cart.prototype.add = function(id, quantity, data, selling_plan) {
      var reload;
      if (quantity == null) {
        quantity = 1;
      }
      if (data == null) {
        data = {};
      }
      data["id"] = id;
      data["quantity"] = quantity;
      if (selling_plan) {
        data["selling_plan"] = selling_plan;
      }
      reload = false;
      return $.ajax("/cart/add.js", {
        method: "POST",
        dataType: "json",
        data: data,
        success: (function(_this) {
          return function(response) {
            var final;
            if (response && response.product_id && window.loyalty.eligible.includes(response.product_id) && !window.loyalty.isVIP && !window.loyalty.isCartVIP) {
              Rubino.subscription_view.showPromo();
            }
            if (response && response.product_id === window.loyalty.productId && !window.loyalty.isVIP && !window.loyalty.isCartVIP) {
              $(".subscription_add_button").prop("disabled", true);
              $(".header--main__top").addClass("vip_header");
              $(".header--main__top .vip_message").removeClass("not_member").attr("href", window.loyalty.texts.VIPUrl).text(window.loyalty.texts.VIPmessage);
              window.loyalty.isCartVIP = true;
              window.sessionStorage.setItem("isCartVIP", true);
              Rubino.subscription_view.hidePromo();
              if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.pageType === "collection" && window.bcsffilter) {
                bcsffilter.getFilterData();
              }
            }
            if (data['final']) {
              if (localStorage.getItem('final')) {
                final = JSON.parse(localStorage.getItem('final'));
              } else {
                final = [];
              }
              final.push(id);
              localStorage.setItem('final', JSON.stringify(final));
            }
            _this.fetch({
              success: function() {
                return _this.trackCart();
              }
            });
            return $.ajax("/cart.js", {
              method: "GET",
              dataType: "json",
              success: function(response) {
                var attributes, loyaltyItem, updateQuantity, updates;
                updates = {};
                updateQuantity = false;
                loyaltyItem = response.items.find((function(item) {
                  return item.product_id === window.loyalty.productId;
                }));
                if (loyaltyItem && loyaltyItem.quantity > 1) {
                  updates[loyaltyItem.variant_id] = 1;
                  updateQuantity = true;
                } else {
                  updates = void 0;
                }
                attributes = response.attributes || {};
                attributes["_is_vip"] = window.loyalty.isVIP || window.loyalty.isCartVIP;
                return $.ajax("/cart/update.js", {
                  method: "POST",
                  dataType: "json",
                  data: {
                    attributes: attributes,
                    updates: updates
                  },
                  success: function(response) {
                    return Rubino.cart_view.show();
                  }
                });
              },
              error: function(error) {
                return Rubino.cart_view.show_error(response.responseJSON.description);
              }
            });
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            return Rubino.cart_view.show_error(response.responseJSON.description);
          };
        })(this)
      });
    };

    Cart.prototype.change = function(key, quantity) {
      var post;
      return post = $.ajax("/cart/change.js", {
        method: "POST",
        dataType: "json",
        data: {
          quantity: quantity,
          id: key
        },
        success: (function(_this) {
          return function(response) {
            var attributes;
            if (response) {
              if (!response.items.find((function(item) {
                return item.product_id === window.loyalty.productId;
              }))) {
                $(".subscription_add_button").prop("disabled", false);
                if (!window.loyalty.isVIP) {
                  $(".header--main__top").removeClass("vip_header");
                  $(".header--main__top .vip_message").addClass("not_member").attr("href", window.loyalty.texts.notVIPUrl).text(window.loyalty.texts.notVIPmessage);
                  $(".vip-price").remove();
                  $(".vip-section").remove();
                }
                window.loyalty.isCartVIP = false;
                window.sessionStorage.removeItem("isCartVIP");
              } else {
                $(".subscription_add_button").prop("disabled", true);
                $(".header--main__top").addClass("vip_header");
                $(".header--main__top .vip_message").removeClass("not_member").attr("href", window.loyalty.texts.VIPUrl).text(window.loyalty.texts.VIPmessage);
                window.loyalty.isCartVIP = true;
                window.sessionStorage.setItem("isCartVIP", true);
              }
            }
            _this.fetch({
              success: function() {
                return _this.trackCart();
              }
            });
            attributes = response.attributes || {};
            attributes["_is_vip"] = window.loyalty.isVIP || window.loyalty.isCartVIP;
            return $.ajax("/cart/update.js", {
              method: "POST",
              dataType: "json",
              data: {
                attributes: attributes
              },
              error: function(error) {
                return console.log("Customer VIP status update failed", error);
              }
            });
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            return Rubino.cart_view.show_error(response.responseJSON.description);
          };
        })(this)
      });
    };

    Cart.prototype.remove = function(key, callback) {
      this.change(key, 0);
      if (callback != null) {
        return callback();
      }
    };

    Cart.prototype.trackCart = function() {
      var cartItem, cartItems, cartItemsArray, final_percent, i, item, len, results;
      cartItemsArray = [];
      cartItems = this.get('items');
      if (window.customer_vip) {
        final_percent = 1 - window.customer_vip;
      } else {
        final_percent = 1;
      }
      results = [];
      for (i = 0, len = cartItems.length; i < len; i++) {
        item = cartItems[i];
        cartItem = {};
        cartItem['item'] = item.id;
        cartItem['price'] = item.final_line_price * final_percent / 100;
        cartItem['quantity'] = item.quantity;
        results.push(cartItemsArray.push(cartItem));
      }
      return results;
    };

    return Cart;

  })(Backbone.Model);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Collections.Feed = (function(superClass) {
    extend(Feed, superClass);

    function Feed() {
      return Feed.__super__.constructor.apply(this, arguments);
    }

    Feed.prototype.parse = function(response) {
      return response.data;
    };

    Feed.prototype.initialize = function(options) {
      if (options == null) {
        options = {};
      }
      this.url = "https://api.instagram.com/v1/users/" + options.user_id + "/media/recent?access_token=" + options.access_token + "&count=" + options.limit;
      return this.fetch();
    };

    Feed.prototype.sync = function(method, collection, options) {
      var params;
      params = _.extend(options, {
        type: 'GET',
        dataType: 'jsonp',
        url: collection.url,
        processData: false
      });
      return $.ajax(params);
    };

    return Feed;

  })(Backbone.Collection);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Slider = (function(superClass) {
    extend(Slider, superClass);

    function Slider() {
      return Slider.__super__.constructor.apply(this, arguments);
    }

    Slider.prototype.current_slide = 0;

    Slider.prototype.events = {
      "click [data-next-slide-button]": "next_slide",
      "click [data-previous-slide-button]": "previous_slide",
      "click [data-slide-marker]": "slide_to"
    };

    Slider.prototype.initialize = function() {
      this.slides_count = this.$el.find("[data-slide]").length;
      return this.render();
    };

    Slider.prototype.render = function() {
      this.$el.find("[data-slide=" + this.current_slide + "]").css("opacity", 1);
      this.reset_autoplay();
      return this;
    };

    Slider.prototype.next_slide = function(e) {
      if (this.current_slide === this.slides_count - 1) {
        return this.slide_to(e, 0);
      } else {
        return this.slide_to(e, this.current_slide + 1);
      }
    };

    Slider.prototype.previous_slide = function(e) {
      if (this.current_slide === 0) {
        return this.slide_to(e, this.slides_count - 1);
      } else {
        return this.slide_to(e, this.current_slide - 1);
      }
    };

    Slider.prototype.slide_to = function(e, index) {
      if (e != null) {
        e.preventDefault();
        e.currentTarget.blur();
        this.reset_autoplay();
      }
      this.current_slide = index;
      this.$el.find("[data-slide-marker]").removeClass("slider__marker--active");
      this.$el.find("[data-slide-marker=" + this.current_slide + "]").addClass("slider__marker--active");
      this.$el.find("[data-slide]").css("opacity", 0.3);
      this.$el.find("[data-slide]").css("transform", "translateX(-" + this.current_slide + "00%)");
      return this.$el.find("[data-slide=" + this.current_slide + "]").css("opacity", 1);
    };

    Slider.prototype.reset_autoplay = function() {
      if (this.el.hasAttribute("data-slider-autoplay")) {
        if (this.interval != null) {
          window.clearInterval(this.interval);
        }
        return this.interval = window.setInterval((function(_this) {
          return function() {
            return _this.next_slide();
          };
        })(this), this.$el.attr("data-slider-autoplay"));
      }
    };

    return Slider;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.fixedNav = (function(superClass) {
    extend(fixedNav, superClass);

    function fixedNav() {
      return fixedNav.__super__.constructor.apply(this, arguments);
    }

    fixedNav.prototype.initialize = function() {
      return this.initializeSticky();
    };

    fixedNav.prototype.initializeSticky = function() {
      var $fixed;
      if (!this.stickyInitialized) {
        $fixed = this.$el.find('[data-nav]');
        if ($fixed.innerHeight() < this.$el.innerHeight()) {
          $fixed.stick_in_parent({
            parent: this.$el,
            innerScrolling: false,
            offset_top: $('header.header--main').height()
          });
          return this.stickyInitialized = true;
        }
      }
    };

    return fixedNav;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Nav = (function(superClass) {
    extend(Nav, superClass);

    function Nav() {
      return Nav.__super__.constructor.apply(this, arguments);
    }

    Nav.prototype.events = {
      "click [data-toggle-cart]": "toggleCart",
      "click [data-toggle-search]": "toggleSearch",
      "click [data-toggle-login]": "toggleLogin",
      "click [data-toggle-account]": "toggleAccount",
      "click [data-toggle-burger]": "toggleBurger",
      "submit [data-search-form]": "submitSearch",
      "click [data-toggler-nav]": "toggleNav",
      "click [data-toggle-sub-nav] > a": "toggleSubNav",
      "click [data-open-mobile-sub-nav] > a": "openMobileSubNav",
      "click [data-close-mobile-sub-nav] > a": "closeMobileSubNav"
    };

    Nav.prototype.initialize = function() {
      this.render();
      return this.bindEvents();
    };

    Nav.prototype.bindEvents = function() {
      return this.$el.find("[data-toggle-sub-nav]").hoverIntent({
        over: function(e) {
          $('html').addClass("noscroll");
          return $(e.currentTarget).addClass('open');
        },
        out: function(e) {
          $('html').removeClass("noscroll");
          return $(e.currentTarget).removeClass('open');
        },
        timeout: 200
      });
    };

    Nav.prototype.render = function() {};

    Nav.prototype.toggleSubNav = function(e) {
      if ($(window).width() < 900) {
        e.preventDefault();
        return $(e.currentTarget).parent().toggleClass('open--mobile');
      }
    };

    Nav.prototype.openMobileSubNav = function(e) {
      e.preventDefault();
      return $(e.currentTarget).parent().find(".header--main__nav__alt-sub").addClass('open--alt-mobile');
    };

    Nav.prototype.closeMobileSubNav = function(e) {
      e.preventDefault();
      return $(e.currentTarget).parent().parent().parent().parent().removeClass('open--alt-mobile');
    };

    Nav.prototype.toggleSuberNav = function(e) {
      e.preventDefault();
      return $(e.currentTarget).closest('[data-suber-nav]').toggleClass('open--mobile');
    };

    Nav.prototype.submitSearch = function(e) {};

    Nav.prototype.toggleCart = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return Rubino.cart_view.toggle();
    };

    Nav.prototype.toggleSearch = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return Rubino.search_view.toggle();
    };

    Nav.prototype.toggleLogin = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return Rubino.login_view.toggle();
    };

    Nav.prototype.toggleAccount = function(e) {
      e.preventDefault();
      $(e.currentTarget).blur();
      return Rubino.account_view.toggle();
    };

    Nav.prototype.toggleNav = function(e) {
      var $parent;
      e.preventDefault();
      $('[data-toggler-nav]').not(e.currentTarget).parent().removeClass('open');
      $parent = $(e.currentTarget).parent();
      $parent.toggleClass('open');
      if (!$parent.hasClass('open')) {
        return $parent.find('nav').slideUp();
      } else {
        return $parent.find('nav').slideDown();
      }
    };

    Nav.prototype.toggleBurger = function(e) {
      $(e.currentTarget).blur();
      if ($("body").hasClass("has_burger")) {
        Rubino.helpers.disableBodyBlock();
        return this.hide_burger(e);
      } else {
        Rubino.helpers.enableBodyBlock();
        return this.showBurger(e);
      }
    };

    Nav.prototype.showBurger = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      $("body").addClass("has_burger");
      $(".main").on("click", (function(_this) {
        return function() {
          return _this.hide_burger();
        };
      })(this));
      return $(".main").on("mouseover", (function(_this) {
        return function() {
          return _this.hide_burger();
        };
      })(this));
    };

    Nav.prototype.hide_burger = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      $("body").removeClass("has_burger");
      $(".main").off("click");
      return $(".main").off("mouseover");
    };

    return Nav;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Accordions = (function(superClass) {
    extend(Accordions, superClass);

    function Accordions() {
      return Accordions.__super__.constructor.apply(this, arguments);
    }

    Accordions.prototype.events = {
      "click [data-toggle-accordion]": "toggleAccordion"
    };

    Accordions.prototype.initialize = function() {
      return this.type = this.el.getAttribute('data-accordions');
    };

    Accordions.prototype.toggleAccordion = function(e) {
      e.preventDefault();
      $(e.currentTarget).closest('[data-accordion]').toggleClass("open");
      if (this.type === 'unique') {
        return this.$el.find('[data-accordion]').not($(e.currentTarget).closest('[data-accordion]')).removeClass("open");
      }
    };

    return Accordions;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Carousel = (function(superClass) {
    extend(Carousel, superClass);

    function Carousel() {
      return Carousel.__super__.constructor.apply(this, arguments);
    }

    Carousel.prototype.initialize = function() {
      this.initCarousel();
      this.detectTheme(0, true);
      return this.bindEvents();
    };

    Carousel.prototype.initCarousel = function() {
      var data;
      data = {
        dots: true,
        arrows: true,
        prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
        nextArrow: '<div class="slick-arrow slick-next"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
        autoplaySpeed: 6000,
        fade: false,
        draggable: false,
        swipe: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              arrows: false,
              dots: true,
              draggable: true,
              swipe: true
            }
          }
        ]
      };
      if (this.$el.data('carousel') === 'product') {
        data = {
          dots: false,
          arrows: true,
          slidesToShow: 3.5,
          infinite: false,
          fade: false,
          draggable: false,
          swipe: false,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                arrows: false,
                slidesToShow: 2.5,
                draggable: true,
                swipe: true
              }
            }, {
              breakpoint: 600,
              settings: {
                arrows: false,
                slidesToShow: 1.5,
                draggable: true,
                swipe: true
              }
            }
          ]
        };
      }
      if (this.$el.data('carousel') === 'logo') {
        data = {
          dots: false,
          arrows: true,
          prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-arrow slick-next"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          slidesToShow: 6,
          slidesToScroll: 6,
          infinite: true,
          fade: false,
          draggable: false,
          swipe: false,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                arrows: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                draggable: true,
                swipe: true
              }
            }, {
              breakpoint: 600,
              settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                draggable: true,
                swipe: true
              }
            }
          ]
        };
      }
      if (this.$el.data('carousel') === 'images') {
        data = {
          dots: false,
          arrows: true,
          prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-arrow slick-next"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          fade: false,
          draggable: false,
          swipe: false
        };
      }
      if (this.$el.data('carousel') === 'products') {
        data = {
          dots: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-arrow slick-next"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          infinite: true,
          fade: false,
          draggable: false,
          swipe: false,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                arrows: false,
                slidesToShow: 1,
                draggable: true,
                swipe: true,
                dots: true
              }
            }, {
              breakpoint: 600,
              settings: {
                arrows: false,
                slidesToShow: 1,
                draggable: true,
                swipe: true,
                dots: true
              }
            }
          ]
        };
      }
      if (this.$el.data('carousel') === 'homepage') {
        data = {
          dots: false,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-arrow slick-next"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          infinite: true,
          fade: false,
          draggable: false,
          swipe: false,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                arrows: false,
                slidesToShow: 1,
                draggable: true,
                swipe: true,
                dots: true
              }
            }, {
              breakpoint: 600,
              settings: {
                arrows: false,
                slidesToShow: 1.3,
                draggable: true,
                swipe: true,
                infinite: false,
                dots: false
              }
            }
          ]
        };
      }
      if (this.$el.data('carousel') === 'product_image') {
        data = {
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-arrow slick-next"><svg class="icon" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          infinite: true,
          fade: false,
          draggable: false,
          swipe: false,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                arrows: false,
                slidesToShow: 1,
                draggable: true,
                swipe: true,
                dots: true
              }
            }, {
              breakpoint: 600,
              settings: {
                arrows: false,
                slidesToShow: 1,
                draggable: true,
                swipe: true,
                dots: true
              }
            }
          ]
        };
      }
      return this.$el.slick(data);
    };

    Carousel.prototype.bindEvents = function() {
      var self;
      self = this;
      this.$el.on('afterChange', function(event, slick, currentSlide, nextSlide) {
        return self.detectTheme();
      });
      this.$el.on('init', function(slick) {
        return $(window).resize();
      });
      this.$el.on('reInit', function(slick) {
        return $(window).resize();
      });
      return this.$el.on('lazyLoaded', function(event, slick, image, imageSource) {
        return $(window).resize();
      });
    };

    Carousel.prototype.detectTheme = function(index, init) {
      var $nextSlide;
      if (init == null) {
        init = false;
      }
      $nextSlide = this.$el.find('.slick-slide.slick-active');
      if (($nextSlide.find('.hero') != null) && $nextSlide.find('.hero').hasClass('hero--dark')) {
        return this.$el.addClass('carousel--dark');
      } else {
        return this.$el.removeClass('carousel--dark');
      }
    };

    return Carousel;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.CartTotal = (function(superClass) {
    extend(CartTotal, superClass);

    function CartTotal() {
      return CartTotal.__super__.constructor.apply(this, arguments);
    }

    CartTotal.prototype.template = templates["cart-total"];

    CartTotal.prototype.data = {};

    CartTotal.prototype.initialize = function() {
      this.listenTo(this.model, "sync", this.render);
      return this.render();
    };

    CartTotal.prototype.render = function() {
      _.extend(this.data, {
        model: this.model.toJSON(),
        text: window.cart_text,
        loyalty: window.loyalty,
        cart_url: window.cart_url
      });
      return this.$el.html(this.template(this.data));
    };

    return CartTotal;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Cart = (function(superClass) {
    extend(Cart, superClass);

    function Cart() {
      return Cart.__super__.constructor.apply(this, arguments);
    }

    Cart.prototype.template = templates["cart"];

    Cart.prototype.data = {};

    Cart.prototype.events = {
      "click [data-add-to-cart]": "add_to_cart",
      "click [data-remove-from-cart]": "remove_from_cart",
      "click [data-edit-from-cart]": "edit_from_cart",
      "click [data-increment]": "increment",
      "click [data-decrement]": "decrement",
      "click [data-close-error]": "close_error",
      "click [data-hide]": "hide",
      "submit [data-form]": "submit"
    };

    Cart.prototype.initialize = function() {
      this.listenTo(this.model, "sync", this.render);
      return this.render();
    };

    Cart.prototype.render = function() {
      _.extend(this.data, {
        model: this.model.toJSON(),
        text: window.cart_text,
        loyalty: window.loyalty,
        cart_url: window.cart_url
      });
      this.$el.html(this.template(this.data));
      return $("[data-item-count]").text(this.model.get("item_count"));
    };

    Cart.prototype.toggle = function(e) {
      if (this.$el.hasClass("cart--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    Cart.prototype.show = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.addClass("cart--show");
      return $('body').addClass('body--cart_open');
    };

    Cart.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.removeClass("cart--show");
      return $('body').removeClass('body--cart_open');
    };

    Cart.prototype.add_to_cart = function(e) {
      e.preventDefault();
      return Rubino.cart.add($(e.currentTarget).attr("data-add-to-cart"));
    };

    Cart.prototype.remove_from_cart = function(e) {
      e.preventDefault();
      return Rubino.cart.remove($(e.currentTarget).attr("data-remove-from-cart"));
    };

    Cart.prototype.edit_from_cart = function(e) {
      var url;
      e.preventDefault();
      url = $(e.currentTarget).attr("data-edit-url");
      return Rubino.cart.remove($(e.currentTarget).attr("data-edit-from-cart"), function() {
        return window.location.href = url;
      });
    };

    Cart.prototype.increment = function(e) {
      var cartItem, key, quantity;
      e.preventDefault();
      key = $(e.currentTarget).attr("data-increment");
      quantity = parseInt($(e.currentTarget).attr("data-current-quantity")) + 1;
      cartItem = window.cart_available.find(((function(_this) {
        return function(item) {
          return item.key === key;
        };
      })(this)));
      if (cartItem && cartItem.av >= quantity) {
        return Rubino.cart.change(key, quantity);
      }
    };

    Cart.prototype.decrement = function(e) {
      e.preventDefault();
      return Rubino.cart.change($(e.currentTarget).attr("data-decrement"), parseInt($(e.currentTarget).attr("data-current-quantity")) - 1);
    };

    Cart.prototype.show_error = function(error) {
      this.$el.find("[data-cart-error-text]").text(error);
      return this.$el.find("[data-cart-error]").removeClass("fade_out");
    };

    Cart.prototype.close_error = function(e) {
      e.preventDefault();
      return this.$el.find("[data-cart-error]").addClass("fade_out");
    };

    Cart.prototype.submit = function(e) {
      e.preventDefault();
      return window.location.href = '/checkout';
    };

    return Cart;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.CartPanel = (function(superClass) {
    extend(CartPanel, superClass);

    function CartPanel() {
      return CartPanel.__super__.constructor.apply(this, arguments);
    }

    CartPanel.prototype.template = templates["cart-panel"];

    CartPanel.prototype.el = $("#cartPanel");

    CartPanel.prototype.data = {};

    CartPanel.prototype.events = {
      "click [data-remove-from-cart]": "remove_from_cart",
      "click [data-edit-from-cart]": "edit_from_cart",
      "click [data-increment]": "increment",
      "click [data-decrement]": "decrement",
      "click [data-close-error]": "close_error",
      "click [data-hide]": "hide",
      "submit [data-form]": "submit",
      "click [data-delivery-option]": "change_delivery_option"
    };

    CartPanel.prototype.initialize = function() {
      this.listenTo(this.model, "sync", this.render);
      return this.render();
    };

    CartPanel.prototype.render = function() {
      _.extend(this.data, {
        model: this.model.toJSON(),
        text: window.cart_text,
        loyalty: window.loyalty,
        cart_url: window.cart_url
      });
      this.$el.html(this.template(this.data));
      $("[data-item-count]").text(this.model.get("item_count"));
      return this;
    };

    CartPanel.prototype.toggle = function(e) {
      if (window.location.pathname !== "/cart") {
        if (this.$el.hasClass("cart--show")) {
          $('html').removeClass("noscroll");
          return this.hide(e);
        } else {
          $('html').addClass("noscroll");
          return this.show(e);
        }
      }
    };

    CartPanel.prototype.show = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      $('html').addClass("noscroll");
      this.$el.addClass("cart--show");
      return $('body').addClass('body--cart_open');
    };

    CartPanel.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      $('html').removeClass("noscroll");
      this.$el.removeClass("cart--show");
      return $('body').removeClass('body--cart_open');
    };

    CartPanel.prototype.remove_from_cart = function(e) {
      e.preventDefault();
      return Rubino.cart.remove($(e.currentTarget).attr("data-remove-from-cart"));
    };

    CartPanel.prototype.edit_from_cart = function(e) {
      var url;
      e.preventDefault();
      url = $(e.currentTarget).attr("data-edit-url");
      return Rubino.cart.remove($(e.currentTarget).attr("data-edit-from-cart"), function() {
        return window.location.href = url;
      });
    };

    CartPanel.prototype.change_delivery_option = function(e) {
      var currentHref, deliveryOption;
      e.preventDefault();
      $(".checkoutMethod.active").removeClass("active");
      deliveryOption = $(e.currentTarget).data("delivery-option");
      $(e.currentTarget).addClass("active");
      currentHref = $("#cart-panel-checkout-button").attr("href");
      if (deliveryOption === "pickup") {
        return $("#cart-panel-checkout-button").attr("href", currentHref.replace("checkout", "cart")).text(window.cart_text.pickup);
      } else if (deliveryOption === "delivery") {
        return $("#cart-panel-checkout-button").attr("href", currentHref.replace("cart", "checkout")).text(window.cart_text.checkout);
      }
    };

    CartPanel.prototype.increment = function(e) {
      var cartItem, key, quantity;
      e.preventDefault();
      key = $(e.currentTarget).attr("data-increment");
      quantity = parseInt($(e.currentTarget).attr("data-current-quantity")) + 1;
      cartItem = window.cart_available.find(((function(_this) {
        return function(item) {
          return item.key === key;
        };
      })(this)));
      if (cartItem && cartItem.av >= quantity) {
        return Rubino.cart.change(key, quantity);
      }
    };

    CartPanel.prototype.decrement = function(e) {
      e.preventDefault();
      return Rubino.cart.change($(e.currentTarget).attr("data-decrement"), parseInt($(e.currentTarget).attr("data-current-quantity")) - 1);
    };

    CartPanel.prototype.show_error = function(error) {
      this.$el.find("[data-cart-error-text]").text(error);
      return this.$el.find("[data-cart-error]").removeClass("fade_out");
    };

    CartPanel.prototype.close_error = function(e) {
      e.preventDefault();
      return this.$el.find("[data-cart-error]").addClass("fade_out");
    };

    CartPanel.prototype.submit = function(e) {
      e.preventDefault();
      return window.location.href = '/checkout';
    };

    return CartPanel;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.CollectionProduct = (function(superClass) {
    extend(CollectionProduct, superClass);

    function CollectionProduct() {
      return CollectionProduct.__super__.constructor.apply(this, arguments);
    }

    CollectionProduct.prototype.events = {
      "mouseenter [data-hover]": "enterSwatch",
      "mouseleave [data-hover]": "leaveSwatch"
    };

    CollectionProduct.prototype.enterSwatch = function(e) {
      var id, newImgSrc;
      id = $(e.currentTarget).data('hover');
      newImgSrc = $(e.currentTarget).data('hover-img');
      this.$el.find('[data-featured-img]').attr('src', newImgSrc);
      this.$el.find('[data-color-name="' + id + '"]').removeClass('hide');
      this.$el.find('[data-color-count]').addClass('hide');
      this.$el.find('[data-product-price]').addClass('hide');
      this.$el.find('[data-product-price="' + id + '"]').removeClass('hide');
      this.$el.find('[data-product-tag]').addClass('hide');
      return this.$el.find('[data-product-tag="' + id + '"]').removeClass('hide');
    };

    CollectionProduct.prototype.leaveSwatch = function(e) {
      var id, oldImgSrc;
      id = $(e.currentTarget).data('hover');
      oldImgSrc = this.$el.find('[data-featured-img]').data('featured-img');
      this.$el.find('[data-featured-img]').attr('src', oldImgSrc);
      this.$el.find('[data-color-name="' + id + '"]').addClass('hide');
      this.$el.find('[data-color-count]').removeClass('hide');
      this.$el.find('[data-product-price]').addClass('hide');
      this.$el.find('[data-product-price]').first().removeClass('hide');
      this.$el.find('[data-product-tag]').addClass('hide');
      return this.$el.find('[data-product-tag]').first().removeClass('hide');
    };

    CollectionProduct.prototype.undelegateEvents = function() {
      return CollectionProduct.__super__.undelegateEvents.call(this);
    };

    return CollectionProduct;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Collection = (function(superClass) {
    extend(Collection, superClass);

    function Collection() {
      return Collection.__super__.constructor.apply(this, arguments);
    }

    Collection.prototype.queryParams = {};

    Collection.prototype.events = {
      "click [data-filter-tag]": "filterTag",
      "change [data-collection-sort]": "sortCollection",
      "click [data-collection-gototop]": "goToTop",
      "mouseenter [data-hover]": "changeSwatch",
      "mouseleave [data-hover]": "resetSwatch",
      "click [data-collection-toggle-row]": "toggleRow",
      "click [data-collection-toggle-row-mobile]": "toggleMobileRow"
    };

    Collection.prototype.filters = [];

    Collection.prototype.initialize = function() {
      return this.setQueryParams();
    };

    Collection.prototype.sortCollection = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.queryParams.sort_by = $(e.currentTarget).val();
      return location.search = $.param(this.queryParams).replace(/\+/g, '%20');
    };

    Collection.prototype.goToTop = function(e) {
      e.preventDefault();
      return $('html, body').animate({
        scrollTop: 0
      }, 600);
    };

    Collection.prototype.setQueryParams = function() {
      var $nav, aKeyValue, i, len, ref, subString;
      if (location.search.length) {
        ref = location.search.substr(1).split('&');
        for (i = 0, len = ref.length; i < len; i++) {
          subString = ref[i];
          aKeyValue = subString.split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      $nav = this.$el.find('[data-scrollspy]');
      return this.$el.find('.section').scrollspy({
        outCallback: function(e) {
          return $nav.find('a[href="#' + e.attr('id') + '"]').removeClass('active');
        },
        inCallback: function(e) {
          return $nav.find('a[href="#' + e.attr('id') + '"]').addClass('active');
        }
      });
    };

    Collection.prototype.filterTag = function(e) {
      var filter, filterClasses, filters, i, len, tag;
      if ($(e.currentTarget).data('filter-type') === 'unique') {
        tag = $(e.currentTarget).data('filter-tag');
        this.$el.find('[data-filter-tag="' + tag + '"]').not(e.currentTarget).prop('checked', false);
      }
      filters = [];
      this.$el.find('[data-filter-tag]').each(function() {
        if ($(this).prop('checked')) {
          return filters.push($(this).val());
        }
      });
      if (filters.length) {
        this.$el.find(".product").addClass("product--disabled");
        filterClasses = "";
        for (i = 0, len = filters.length; i < len; i++) {
          filter = filters[i];
          filterClasses += "." + filter;
        }
        this.$el.find(".product" + filterClasses).removeClass("product--disabled").addClass("product--highlight");
        return this.$el.find(".product").not(filterClasses).addClass("product--disabled").removeClass("product--highlight");
      } else {
        return this.$el.find(".product").removeClass("product--disabled").removeClass("product--highlight");
      }
    };

    Collection.prototype.changeSwatch = function(e) {
      var $product, newImgSrc, swatchId;
      swatchId = $(e.currentTarget).data('hover');
      newImgSrc = $(e.currentTarget).data('hover-img');
      $product = $(e.currentTarget).closest('[data-collection-product]');
      if ($product.find('[data-product-price]').length) {
        $product.find('[data-product-price]').addClass('hide');
        $product.find('[data-product-price="' + swatchId + '"]').removeClass('hide');
      }
      if ($product.find('[data-product-tag]').length) {
        $product.find('[data-product-tag]').addClass('hide');
        $product.find('[data-product-tag="' + swatchId + '"]').removeClass('hide');
      }
      if ($product.find('[data-color-name]').length) {
        $product.find('[data-color-name]').addClass('hide');
        $product.find('[data-color-name="' + swatchId + '"]').removeClass('hide');
      }
      $product.find('[data-color-count]').addClass('hide');
      if (newImgSrc) {
        return $product.find('[data-featured-img]').attr('src', newImgSrc);
      }
    };

    Collection.prototype.resetSwatch = function(e) {
      var $product, oldImgSrc;
      $product = $(e.currentTarget).closest('[data-collection-product]');
      oldImgSrc = $product.find('[data-featured-img]').data('featured-img');
      if ($product.find('[data-product-price]').length) {
        $product.find('[data-product-price]').addClass('hide');
        $product.find('[data-product-price]').first().removeClass('hide');
      }
      if ($product.find('[data-product-tag]').length) {
        $product.find('[data-product-tag]').addClass('hide');
        $product.find('[data-product-tag]').first().removeClass('hide');
      }
      if ($product.find('[data-color-name]').length) {
        $product.find('[data-color-name]').addClass('hide');
      }
      $product.find('[data-color-count]').removeClass('hide');
      return $product.find('[data-featured-img]').attr('src', oldImgSrc);
    };

    Collection.prototype.toggleRow = function(e) {
      e.preventDefault();
      $(e.currentTarget).find('svg').toggleClass('hide');
      if (this.$el.find('.col--product').first().hasClass("col--3of12")) {
        return this.$el.find('.col--product').addClass("col--4of12").removeClass("col--3of12");
      } else {
        return this.$el.find('.col--product').removeClass("col--4of12").addClass("col--3of12");
      }
    };

    Collection.prototype.toggleMobileRow = function(e) {
      e.preventDefault();
      $(e.currentTarget).find('svg').toggleClass('hide');
      if (this.$el.find('.col--product').first().hasClass("col--tablet_portrait--12of12")) {
        return this.$el.find('.col--product').addClass("col--tablet_portrait--6of12").removeClass("col--tablet_portrait--12of12");
      } else {
        return this.$el.find('.col--product').removeClass("col--tablet_portrait--6of12").addClass("col--tablet_portrait--12of12");
      }
    };

    return Collection;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Collection2 = (function(superClass) {
    extend(Collection2, superClass);

    function Collection2() {
      return Collection2.__super__.constructor.apply(this, arguments);
    }

    Collection2.prototype.initialize = function() {
      return this.writeCollectionURL();
    };

    Collection2.prototype.writeCollectionURL = function() {
      return Rubino.cookies.set('collectionUrlParams', window.location.search);
    };

    return Collection2;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.FAQ = (function(superClass) {
    extend(FAQ, superClass);

    function FAQ() {
      return FAQ.__super__.constructor.apply(this, arguments);
    }

    FAQ.prototype.events = {
      "click [data-toggle-section]": "toggleSection"
    };

    FAQ.prototype.initialize = function() {
      return this.checkSectionParams();
    };

    FAQ.prototype.toggleSection = function(e) {
      var section;
      e.preventDefault();
      section = $(e.currentTarget).data('toggle-section');
      this.$el.find('[data-section="' + section + '"]').slideToggle();
      return $(e.currentTarget).toggleClass('active');
    };

    FAQ.prototype.checkSectionParams = function() {
      var position, section, urlParams;
      urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('s') != null) {
        section = urlParams.get('s');
        this.$el.find('[data-section="' + section + '"]').show();
        this.$el.find('[data-toggle-section="' + section + '"]').toggleClass('active');
        position = this.$el.offset().top;
        history.scrollRestoration = 'manual';
        return window.scroll(0, position - 150);
      }
    };

    return FAQ;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Feed = (function(superClass) {
    var interval, username;

    extend(Feed, superClass);

    function Feed() {
      return Feed.__super__.constructor.apply(this, arguments);
    }

    interval = null;

    username = '';

    Feed.prototype.initialize = function() {
      this.username = this.$el.data('feed-username');
      return this.interval = setInterval((function(_this) {
        return function() {
          return _this.checkFeed();
        };
      })(this), 500);
    };

    Feed.prototype.checkFeed = function() {
      if (this.$el.find('#rap__med__insta').length) {
        clearInterval(this.interval);
        return this.injectHeader();
      }
    };

    Feed.prototype.injectHeader = function() {
      var headerHtml;
      headerHtml = '<div class="feed__banner"><div class="feed__banner__inner">';
      headerHtml += '<h3>';
      headerHtml += window.feed_text["follow"] + ' <a href="https://instagram.com/' + this.username + '" target="_blank">@' + this.username + '</a> ' + window.feed_text["on_ig"];
      headerHtml += '</h3>';
      headerHtml += '</div></div>';
      return this.$el.find('#rap__med__insta').prepend(headerHtml);
    };

    return Feed;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Filters = (function(superClass) {
    extend(Filters, superClass);

    function Filters() {
      return Filters.__super__.constructor.apply(this, arguments);
    }

    Filters.prototype.activeFilters = [];

    Filters.prototype.url = null;

    Filters.prototype.params = null;

    Filters.prototype.events = {
      'click [data-add-filter]': 'addFilter',
      'click [data-toggle-filter-nav]': 'toggleFilterNav',
      'click [data-reset-filter]': 'resetFilter',
      'click [data-show-filters]': 'showFilters'
    };

    Filters.prototype.initialize = function() {
      if (this.$el.data('filters') !== '') {
        this.activeFilters = this.$el.data('filters').split('|');
      }
      this.url = this.$el.data('filters-url');
      if (this.$el.data('filters-params') != null) {
        this.params = this.$el.data('filters-params');
      }
      return Filters.__super__.initialize.call(this);
    };

    Filters.prototype.addFilter = function(e) {
      var _filter, filter, filterArray, filterExists, filterIndex, filterName, i, index, len, ref;
      e.preventDefault();
      filter = $(e.currentTarget).data('add-filter');
      filterArray = filter.split(':');
      filterName = filterArray[0];
      ref = this.activeFilters;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        _filter = ref[index];
        if (_filter.indexOf(filterName) !== -1) {
          filterIndex = index;
        }
        if (_filter.indexOf(filter) !== -1) {
          filterExists = true;
        }
      }
      if (filterExists) {
        this.activeFilters.splice(filterIndex, 1);
      } else if (filterIndex != null) {
        this.activeFilters[filterIndex] = filter;
      } else {
        this.activeFilters.push(filter);
      }
      return this.applyFilters();
    };

    Filters.prototype.applyFilters = function() {
      var filter, i, index, len, ref, url;
      url = this.url + '/';
      ref = this.activeFilters;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        filter = ref[index];
        url += filter;
        if ((index + 1) < this.activeFilters.length) {
          url += '+';
        }
      }
      if (this.params != null) {
        url += '/?sort_by=' + this.params;
      }
      return window.location.href = url;
    };

    Filters.prototype.resetFilter = function(e) {
      e.preventDefault();
      return window.location.href = this.url;
    };

    Filters.prototype.toggleFilterNav = function(e) {
      e.preventDefault();
      if ($(e.currentTarget).closest('nav').hasClass('open')) {
        $(e.currentTarget).closest('nav').removeClass('open');
        return $(e.currentTarget).closest('nav').find('ul').slideUp();
      } else {
        $(e.currentTarget).closest('nav').addClass('open');
        return $(e.currentTarget).closest('nav').find('ul').slideDown();
      }
    };

    Filters.prototype.showFilters = function(e) {
      e.preventDefault();
      if (this.$el.hasClass('open')) {
        this.$el.removeClass('open');
        return this.$el.find('[data-filters-content]').slideUp();
      } else {
        this.$el.addClass('open');
        return this.$el.find('[data-filters-content]').slideDown();
      }
    };

    return Filters;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Footer = (function(superClass) {
    extend(Footer, superClass);

    function Footer() {
      return Footer.__super__.constructor.apply(this, arguments);
    }

    Footer.prototype.events = {
      "click [data-show-newsletter]": "showNewsletter"
    };

    Footer.prototype.initialize = function() {
      this.initFirstWord();
      this.bindEvents();
      return this.addReturnsFRLinks();
    };

    Footer.prototype.initFirstWord = function() {
      return $('[data-first-word]').each(function() {
        var firstWord, firstWordPosition, rest, string;
        string = $(this).html();
        firstWordPosition = string.indexOf(" ");
        firstWord = string.substr(0, firstWordPosition);
        rest = string.substr(firstWordPosition + 1);
        string = firstWord + ' <span>' + rest + '</span>';
        return $(this).html(string);
      });
    };

    Footer.prototype.bindEvents = function() {
      $('a[data-anchor]').click((function(_this) {
        return function(e) {
          var gutter, position, selector;
          e.preventDefault();
          selector = $(e.currentTarget).data('anchor');
          gutter = $('[data-header]').innerHeight();
          position = $(selector).offset().top;
          return $('html, body').animate({
            scrollTop: position - gutter - 30
          }, 600);
        };
      })(this));
      return $('select[data-anchor]').on('blur', (function(_this) {
        return function(e) {
          var gutter, position, selector;
          e.preventDefault();
          selector = $(e.currentTarget).val();
          gutter = $('[data-header]').innerHeight();
          position = $(selector).offset().top - gutter;
          return $('html, body').animate({
            scrollTop: position
          }, 600);
        };
      })(this));
    };

    Footer.prototype.showNewsletter = function(e) {
      e.preventDefault();
      Rubino.newsletter_view.show();
      return Rubino.newsletter_view.$el.find("[name='email']").focus();
    };

    Footer.prototype.initBlank = function() {
      return $('a[href^="http"]').not('a[href^="' + $(location).attr('hostname') + '"]').attr('target', '_blank');
    };

    Footer.prototype.addReturnsFRLinks = function() {
      if (location.pathname.includes('/fr')) {
        return $('a[href*="/apps/returns"]').each(function() {
          var href;
          href = $(this).attr('href');
          if (!href.includes('?lang=fr')) {
            return $(this).attr('href', href + '?lang=fr');
          }
        });
      }
    };

    return Footer;

  })(Backbone.View);

}).call(this);

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Form = (function(superClass) {
    extend(Form, superClass);

    function Form() {
      this.formCallback = bind(this.formCallback, this);
      return Form.__super__.constructor.apply(this, arguments);
    }

    Form.prototype.initialize = function() {
      var formLang, formURL;
      formURL = this.$el.data('form-url');
      formLang = this.$el.data('form-lang');
      this.formType = this.$el.data('form');
      if (formURL) {
        return this.$el.ajaxChimp({
          callback: this.formCallback,
          url: formURL,
          lang: formLang
        });
      }
    };

    Form.prototype.events = {
      'submit': 'triggerSubmit'
    };

    Form.prototype.formCallback = function(resp) {
      debugger;
      if (resp.result === 'success') {
        if ($('[data-form-success]').length) {
          $('[data-form-form]').addClass('hide');
          return $('[data-form-success]').removeClass('hide');
        }
      } else {
        if ($('[data-form-error]').length) {
          $('[data-form-error]').removeClass('hide');
          return $('[data-form-error]').html(resp.msg);
        }
      }
    };

    Form.prototype.triggerSubmit = function(e) {
      if (!this.formType === !'address') {
        e.preventDefault();
        if ($('[data-form-error]').length) {
          $('[data-form-error]').addClass('hide');
          $('[data-form-error]').html('');
        }
        if (this.formType === 'newsletter-signup') {
          return Rubino.contact.createOrUpdate(this.$el.find('[name="email"]').val(), this.$el.find('[name="first_name"]').val(), this.$el.find('[name="last_name"]').val());
        }
      }
    };

    return Form;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.GiftCardForm = (function(superClass) {
    extend(GiftCardForm, superClass);

    function GiftCardForm() {
      return GiftCardForm.__super__.constructor.apply(this, arguments);
    }

    GiftCardForm.prototype.id = null;

    GiftCardForm.prototype.events = {
      "click [data-giftcard-type='new']": "showNew",
      "click [data-giftcard-type='old']": "showOld"
    };

    GiftCardForm.prototype.initialize = function() {};

    GiftCardForm.prototype.showNew = function() {
      this.$el.find('[data-giftcard-type="old"]').addClass('button--outline');
      this.$el.find('[data-giftcard-type="old"]').removeClass('button--solid');
      this.$el.find('[data-giftcard-form="old"]').addClass('hide');
      this.$el.find('[data-giftcard-input="old"]').attr('disabled', true);
      this.$el.find('[data-giftcard-type="new"]').removeClass('button--outline');
      this.$el.find('[data-giftcard-type="new"]').addClass('button--solid');
      this.$el.find('[data-giftcard-form="new"]').removeClass('hide');
      this.$el.find('[data-giftcard-input="new"]').attr('disabled', false);
      return this.$el.find('[data-giftcard-submit]').removeClass('hide');
    };

    GiftCardForm.prototype.showOld = function() {
      this.$el.find('[data-giftcard-type="new"]').addClass('button--outline');
      this.$el.find('[data-giftcard-type="new"]').removeClass('button--solid');
      this.$el.find('[data-giftcard-form="new"]').addClass('hide');
      this.$el.find('[data-giftcard-input="new"]').attr('disabled', true);
      this.$el.find('[data-giftcard-type="old"]').removeClass('button--outline');
      this.$el.find('[data-giftcard-type="old"]').addClass('button--solid');
      this.$el.find('[data-giftcard-form="old"]').removeClass('hide');
      this.$el.find('[data-giftcard-input="old"]').attr('disabled', false);
      return this.$el.find('[data-giftcard-submit]').removeClass('hide');
    };

    return GiftCardForm;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Header = (function(superClass) {
    extend(Header, superClass);

    function Header() {
      return Header.__super__.constructor.apply(this, arguments);
    }

    Header.prototype.theme = null;

    Header.prototype.initialize = function() {
      return this.render();
    };

    Header.prototype.events = {
      "click [data-menu-toggler]": "toggleMenu",
      "click [data-nav-toggler]": "toggleNav",
      "click [data-header-close-top]": "hideTopContent"
    };

    Header.prototype.render = function() {
      this.initSlider();
      return this.showTopContent();
    };

    Header.prototype.showTopContent = function() {
      if (this.$el.find('[data-header-top]').length && (Rubino.cookies.get("top_hidden") == null)) {
        return $('body').addClass('show_top');
      }
    };

    Header.prototype.hideTopContent = function(e) {
      e.preventDefault();
      Rubino.cookies.set("top_hidden", true, 14);
      return $('body').removeClass('show_top');
    };

    Header.prototype.initSlider = function() {
      if (this.$el.find('[data-slider]').children().length > 1) {
        return this.$el.find('[data-slider]').slick({
          autoplay: true,
          infinite: true,
          fade: true,
          draggable: false,
          swipe: false,
          arrows: true,
          prevArrow: '<div class="slick-arrow slick-prev"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-left"></use></svg></div>',
          nextArrow: '<div class="slick-arrow slick-next"><svg class="icon icon--strokes" stroke-width="1"><use xlink:href="#icon-arrow-right"></use></svg></div>',
          dots: false,
          autoplaySpeed: 3000
        });
      }
    };

    return Header;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Hero = (function(superClass) {
    extend(Hero, superClass);

    function Hero() {
      return Hero.__super__.constructor.apply(this, arguments);
    }

    Hero.prototype.initialize = function() {
      return this.detectTheme();
    };

    Hero.prototype.detectTheme = function() {
      if (this.$el.hasClass('hero--under')) {
        if (this.$el.hasClass('hero--dark')) {
          return $('body').trigger('hero:theme', 'dark');
        } else {
          return $('body').trigger('hero:theme', 'light');
        }
      }
    };

    return Hero;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Login = (function(superClass) {
    extend(Login, superClass);

    function Login() {
      return Login.__super__.constructor.apply(this, arguments);
    }

    Login.prototype.el = $("#login");

    Login.prototype.data = {};

    Login.prototype.events = {
      "click [data-hide]": "hide",
      "submit #customer_login": "customer_login",
      "submit #create_customer": "create_customer",
      "click [data-submit]": "submit_form",
      "click [data-slide-marker]": "slide_to"
    };

    Login.prototype.initialize = function() {
      return Login.__super__.initialize.call(this);
    };

    Login.prototype.render = function() {
      return Login.__super__.render.call(this);
    };

    Login.prototype.customer_login = function(e) {
      e.preventDefault();
      return $.ajax(e.currentTarget.getAttribute("action"), {
        method: "POST",
        dataType: "html",
        data: {
          "customer[email]": e.currentTarget["customer[email]"].value,
          "customer[password]": e.currentTarget["customer[password]"].value,
          form_type: "customer_login",
          utf8: "✓"
        },
        success: (function(_this) {
          return function(response) {
            var errors;
            errors = $(response).find(".errors");
            if (errors.length > 0) {
              return $(e.currentTarget).find("[data-errors]").text(errors.text());
            } else {
              $(e.currentTarget).find("[data-errors]").text("");
              window.location.reload();
              return _this.hide();
            }
          };
        })(this)
      });
    };

    Login.prototype.create_customer = function(e) {
      e.preventDefault();
      return $.ajax(e.currentTarget.getAttribute("action"), {
        method: "POST",
        data: {
          "customer[email]": e.currentTarget["customer[email]"].value,
          "customer[password]": e.currentTarget["customer[password]"].value,
          "customer[first_name]": e.currentTarget["customer[first_name]"].value,
          "customer[last_name]": e.currentTarget["customer[last_name]"].value,
          form_type: "create_customer",
          utf8: "✓"
        },
        success: (function(_this) {
          return function(response) {
            var errors;
            errors = $(response).find(".errors");
            if (errors.length > 0) {
              return $(e.currentTarget).find("[data-errors]").text(errors.text());
            } else {
              $(e.currentTarget).find("[data-errors]").text("");
              Turbolinks.visit("/account");
              return _this.hide();
            }
          };
        })(this)
      });
    };

    Login.prototype.toggle = function(e) {
      if (this.$el.hasClass("overlay--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    Login.prototype.show = function(e, index) {
      if (index == null) {
        index = 0;
      }
      if (e != null) {
        e.preventDefault();
      }
      this.$el.find("#login_email").focus();
      return this.$el.addClass("overlay--show");
    };

    Login.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      return this.$el.removeClass("overlay--show");
    };

    return Login;

  })(Rubino.Views.Slider);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Newsletter = (function(superClass) {
    extend(Newsletter, superClass);

    function Newsletter() {
      return Newsletter.__super__.constructor.apply(this, arguments);
    }

    Newsletter.prototype.events = {
      "submit form": "signup"
    };

    Newsletter.prototype.signup = function(e) {
      e.preventDefault();
      window.omnisend = window.omnisend || [];
      return omnisend.push([
        "contacts", "create", {
          email: $(e.currentTarget).find('[name="email"]').val()
        }
      ]);
    };

    Newsletter.prototype.toggleSection = function(section) {
      $('[data-section]').addClass('hide');
      return $('[data-section="' + section + '"]').removeClass('hide');
    };

    return Newsletter;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.NewsletterPopUp = (function(superClass) {
    extend(NewsletterPopUp, superClass);

    function NewsletterPopUp() {
      return NewsletterPopUp.__super__.constructor.apply(this, arguments);
    }

    NewsletterPopUp.prototype.el = $("#newsletter");

    NewsletterPopUp.prototype.count = 0;

    NewsletterPopUp.prototype.data = {};

    NewsletterPopUp.prototype.events = {
      "click [data-hide]": "hide"
    };

    NewsletterPopUp.prototype.initialize = function() {
      this.countClicks();
      return document.addEventListener("turbolinks:load", (function(_this) {
        return function() {
          return _this.countClicks();
        };
      })(this));
    };

    NewsletterPopUp.prototype.toggle = function(e) {
      if (this.$el.hasClass("newsletter--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    NewsletterPopUp.prototype.show = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.addClass("newsletter--show");
      return this.$el.find("[type='email']").focus();
    };

    NewsletterPopUp.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.removeClass("newsletter--show");
      Rubino.cookies.set("newsletter_hidden", true);
      return setTimeout((function(_this) {
        return function() {
          return _this.toggleSection('form');
        };
      })(this), 1000);
    };

    NewsletterPopUp.prototype.countClicks = function() {
      if ((Rubino.cookies.get("newsletter_hidden") == null) && this.$el.data("newsletter-delay") !== 'never') {
        if (Rubino.cookies.get("newsletter_clicks") != null) {
          this.count = parseInt(Rubino.cookies.get("newsletter_clicks"));
          this.count++;
          if (this.count >= this.$el.data("newsletter-clicks")) {
            this.trigger();
            this.count = 0;
          }
        }
        return Rubino.cookies.set("newsletter_clicks", this.count);
      }
    };

    NewsletterPopUp.prototype.trigger = function() {
      return setTimeout((function(_this) {
        return function() {
          return _this.show();
        };
      })(this), this.$el.data("newsletter-delay") * 1000);
    };

    NewsletterPopUp.prototype.toggleSection = function(section) {
      $('[data-section]').addClass('hide');
      return $('[data-section="' + section + '"]').removeClass('hide');
    };

    return NewsletterPopUp;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.NewsletterSection = (function(superClass) {
    extend(NewsletterSection, superClass);

    function NewsletterSection() {
      return NewsletterSection.__super__.constructor.apply(this, arguments);
    }

    NewsletterSection.prototype.data = {};

    NewsletterSection.prototype.events = {
      "keyup [data-email]": "show",
      'submit': 'triggerSubmit'
    };

    NewsletterSection.prototype.initialize = function() {
      this.current = this.$el.find("[data-email]");
      this.hidden = this.$el.find(".newsletter--section-hidden-fields");
      this.fields = this.$el.find(".newsletter--section-fields");
      return this.message = this.$el.find(".newsletter--section-message");
    };

    NewsletterSection.prototype.show = function(e) {
      return this.hidden.removeClass("hidden");
    };

    NewsletterSection.prototype.triggerSubmit = function(e) {
      var prefs;
      e.preventDefault();
      prefs = [];
      this.$el.find('[name="shopping_prefs[]"]').each(function() {
        if ($(this).prop('checked')) {
          return prefs.push($(this).val());
        }
      });
      Rubino.contact.createOrUpdate(this.$el.find('[name="email"]').val(), this.$el.find('[name="first_name"]').val(), this.$el.find('[name="last_name"]').val(), this.$el.find('[name="lang"]').val(), true, this.$el.find('[name="birthday_y"]').val(), this.$el.find('[name="birthday_m"]').val(), this.$el.find('[name="birthday_d"]').val(), prefs.join(",")).done(this.success).fail(this.error);
      this.fields.addClass("hidden");
      return this.message.removeClass("hidden");
    };

    return NewsletterSection;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Product = (function(superClass) {
    extend(Product, superClass);

    function Product() {
      return Product.__super__.constructor.apply(this, arguments);
    }

    Product.prototype.stickyInitialized = false;

    Product.prototype.initializedZoom = false;

    Product.prototype.events = {
      "click input[name='color']": "changeVariant",
      "change select[name='color']": "changeVariant",
      "click input[name='size']": "changeSize",
      "click [data-thumb-img]": "goToSlide",
      "submit [data-add-to-cart-form]": "addToCart",
      "click [data-show-sizing]": "showSizing",
      "click [data-hide-sizing]": "hideSizing",
      "click [data-product-increment]": "incrementQty",
      "click [data-product-toggle-accordion]": "toggleAccordion",
      "mouseenter [data-hover]": "changeSwatch",
      "mouseleave [data-hover]": "resetSwatch",
      "mouseenter [data-low]": "showLowStock",
      "mouseleave [data-low]": "hideLowStock",
      "click [data-hide-shipping-delay]": "hideShippingDelay"
    };

    Product.prototype.initialize = function() {
      var $current;
      $current = this.$el.find("[name='size']:checked");
      this.current_color = $current.attr("data-color");
      this.current_size = $current.attr("data-size");
      this.render();
      return this.setBreadrcrumbHref();
    };

    Product.prototype.render = function() {
      this.initializeCarousel();
      return this.initializeZoom();
    };

    Product.prototype.setBreadrcrumbHref = function() {
      var href;
      if (Rubino.cookies.get('collectionUrlParams') != null) {
        href = $('[data-product-breadcrumb]').attr('href');
        href += Rubino.cookies.get('collectionUrlParams');
        Rubino.cookies["delete"]('collectionUrlParams');
        return $('[data-product-breadcrumb]').attr('href', href);
      }
    };

    Product.prototype.initializeZoom = function() {
      if ($(window).width() > 1200) {
        return this.$el.find("[data-zoom]").each(function() {
          return $(this).zoom({
            on: 'click',
            url: $(this).data('zoom'),
            duration: 0,
            onZoomIn: (function(_this) {
              return function() {
                return $(_this).addClass('zoomed_in');
              };
            })(this),
            onZoomOut: (function(_this) {
              return function() {
                return $(_this).removeClass('zoomed_in');
              };
            })(this)
          });
        });
      }
    };

    Product.prototype.changeVariant = function(e) {
      var $size, id;
      this.current_color = $(e.currentTarget).val();
      $size = this.$el.find('[name="size"][data-color="' + this.current_color + '"][data-size="' + this.current_size + '"]');
      if (!$size.prop('disabled')) {
        id = $size.val();
      } else {
        id = this.$el.find('[name="size"][data-color="' + this.current_color + '"]:not([disabled])').first().val();
      }
      if (id == null) {
        id = this.$el.find('[name="size"][data-color="' + this.current_color + '"]').first().val();
      }
      if (id != null) {
        window.location.href = window.location.pathname + "?variant=" + id;
      } else {
        window.location.href = window.location.pathname + "?variant=" + e.currentTarget.value;
      }
      return this.$el.find("[name='qty']").val(1);
    };

    Product.prototype.changeSize = function(e) {
      var id;
      id = $(e.currentTarget).val();
      this.current_size = $(e.currentTarget).attr("data-size");
      this.$el.find('[data-product-submit]').removeAttr("disabled");
      if ($(e.currentTarget).data('history') != null) {
        window.history.pushState({}, 'variant-' + id, $(e.currentTarget).data('history'));
      }
      return this.$el.find("[name='qty']").val(1);
    };

    Product.prototype.goToSlide = function(e) {
      var index;
      e.preventDefault();
      index = $(e.currentTarget).index();
      return this.$el.find('[data-product-carousel]').slick('slickGoTo', index);
    };

    Product.prototype.showSizing = function(e) {
      var $sizing;
      e.preventDefault();
      $sizing = $('[data-sizing]');
      $sizing.addClass('overlay--show');
      return $('body').addClass('body--freeze');
    };

    Product.prototype.hideSizing = function(e) {
      var $sizing;
      e.preventDefault();
      $sizing = $('[data-sizing]');
      $sizing.removeClass('overlay--show');
      return $('body').removeClass('body--freeze');
    };

    Product.prototype.hideShippingDelay = function(e) {
      var $sizing;
      e.preventDefault();
      $sizing = $(".shipping-delay");
      return $sizing.addClass('hidden');
    };

    Product.prototype.initializeCarousel = function() {
      return this.$el.find('[data-product-carousel]').slick({
        dots: true,
        arrows: false,
        autoplay: false,
        fade: false,
        draggable: false,
        swipe: true,
        infinite: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 600,
            settings: "unslick"
          }
        ]
      });
    };

    Product.prototype.changeSwatch = function(e) {
      var swatchId;
      swatchId = $(e.currentTarget).data('hover');
      this.$el.find('[data-product-price]').addClass('hide');
      this.$el.find('[data-product-price="' + swatchId + '"]').removeClass('hide');
      this.$el.find('[data-color-name]').addClass('hide');
      this.$el.find('[data-color-name="' + swatchId + '"]').removeClass('hide');
      return this.$el.find("[name='qty']").val(1);
    };

    Product.prototype.resetSwatch = function(e) {
      this.$el.find('[data-product-price]').addClass('hide');
      this.$el.find('[data-product-default-price]').removeClass('hide');
      this.$el.find('[data-color-name]').addClass('hide');
      this.$el.find('[data-default-color-name]').removeClass('hide');
      return this.$el.find("[name='qty']").val(1);
    };

    Product.prototype.incrementQty = function(e) {
      var $qty, currentAvailable, id, increment, newQty, qty;
      e.preventDefault();
      $qty = this.$el.find("[name='qty']");
      qty = parseInt($qty.val());
      increment = $(e.currentTarget).data('product-increment');
      id = this.$el.find("[name='size']:checked").val();
      currentAvailable = window.variants_available[id];
      if (currentAvailable >= qty + increment) {
        newQty = qty + increment;
        if (newQty < 1) {
          newQty = 1;
        }
        return this.$el.find("[name='qty']").val(newQty);
      }
    };

    Product.prototype.addToCart = function(e, data) {
      var id, properties, qty, selling_plan;
      if (data == null) {
        data = {};
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      qty = 1;
      selling_plan = null;
      if (this.$el.find("[name='selling_plan']").length) {
        selling_plan = this.$el.find("[name='selling_plan']").val();
      }
      if (this.$el.find("[name='qty']").length) {
        qty = this.$el.find("[name='qty']").val();
      }
      properties = {};
      data['properties'] = {};
      if ($(e.currentTarget).find('[data-product-submit]').data('final') != null) {
        data['final'] = true;
        data['properties']["_price_change_code"] = 'Liquidation';
      }
      if ($(e.currentTarget).find('[data-product-submit]').data('vipEligible') != null) {
        data['properties']["_vip_eligible"] = true;
      }
      id = this.$el.find("[name='size']:checked").val();
      return Rubino.cart.add(this.$el.find("[name='size']:checked").val(), qty, data, selling_plan);
    };

    Product.prototype.toggleAccordion = function(e) {
      e.preventDefault();
      if ($(e.currentTarget).closest('[data-product-accordion]').hasClass('open')) {
        $(e.currentTarget).closest('[data-product-accordion]').removeClass('open');
        return $(e.currentTarget).closest('[data-product-accordion]').find('> div').slideUp();
      } else {
        $(e.currentTarget).closest('[data-product-accordion]').addClass('open');
        return $(e.currentTarget).closest('[data-product-accordion]').find('> div').slideDown();
      }
    };

    Product.prototype.showLowStock = function() {
      this.$el.find('[data-low-label] span').first().addClass('hide');
      return this.$el.find('[data-low-label] span').last().removeClass('hide');
    };

    Product.prototype.hideLowStock = function() {
      this.$el.find('[data-low-label] span').first().removeClass('hide');
      return this.$el.find('[data-low-label] span').last().addClass('hide');
    };

    return Product;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.CustomProduct = (function(superClass) {
    extend(CustomProduct, superClass);

    function CustomProduct() {
      return CustomProduct.__super__.constructor.apply(this, arguments);
    }

    CustomProduct.prototype.events = {
      "click [name='variant']": "change_variant",
      "click [data-add-product]": "add_product",
      "click [data-add-to-cart]": "add_to_cart",
      "click [data-product-spot]": "remove_product"
    };

    CustomProduct.prototype.products = [];

    CustomProduct.prototype.size = 0;

    CustomProduct.prototype.initialize = function() {
      return CustomProduct.__super__.initialize.call(this);
    };

    CustomProduct.prototype.render = function() {
      var i, index, len, product, ref;
      this.size = parseInt(this.$el.attr("data-custom-size"));
      if (this.size < this.products.length) {
        this.products = this.products.slice(0, this.size);
      }
      this.spots = this.$el.find("[data-product-spot]");
      this.spots.attr("data-product-spot", "");
      this.spots.attr("src", "");
      ref = this.products;
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        product = ref[index];
        this.spots[index].setAttribute("data-product-spot", product.title);
        this.spots[index].setAttribute("src", product.image);
      }
      this.$el.find("[data-add-to-cart]").attr("disabled", this.products.length !== this.size);
      return CustomProduct.__super__.render.call(this);
    };

    CustomProduct.prototype.add_to_cart = function(e, data) {
      var i, len, product, products_text, ref;
      if (data == null) {
        data = {};
      }
      products_text = "";
      ref = this.products;
      for (i = 0, len = ref.length; i < len; i++) {
        product = ref[i];
        products_text += product.title + ", ";
      }
      data["properties[" + this.$el.attr("data-custom-label") + "]"] = products_text.substring(0, products_text.length - 2);
      return CustomProduct.__super__.add_to_cart.call(this, e, data);
    };

    CustomProduct.prototype.add_product = function(e) {
      e.preventDefault();
      if (this.products.length < this.size) {
        this.products.push({
          title: e.currentTarget.getAttribute("data-add-product"),
          image: e.currentTarget.getAttribute("data-add-product-image")
        });
        return this.render();
      }
    };

    CustomProduct.prototype.remove_product = function(e) {
      e.preventDefault();
      this.products.splice(this.spots.index(e.currentTarget), 1);
      return this.render();
    };

    return CustomProduct;

  })(Rubino.Views.Product);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Promo = (function(superClass) {
    extend(Promo, superClass);

    function Promo() {
      return Promo.__super__.constructor.apply(this, arguments);
    }

    Promo.prototype.id = null;

    Promo.prototype.events = {
      "click [data-promo-hide]": "hidePromo",
      "click [data-promo-toggle]": "togglePromo"
    };

    Promo.prototype.initialize = function() {
      this.id = this.$el.data('promo');
      this.delay = this.$el.data('delay');
      this.restricted = this.$el.data('restricted-show');
      if (!(Rubino.cookies.get("promo_hidden--" + this.id) || (this.restricted != null))) {
        return setTimeout((function(_this) {
          return function() {
            return _this.togglePromo();
          };
        })(this), Number(this.delay) * 1000);
      }
    };

    Promo.prototype.hidePromo = function() {
      Rubino.cookies.set("promo_hidden--" + this.id, true);
      $('html').removeClass("noscroll");
      return this.$el.find('[data-promo-overlay]').removeClass('overlay--show');
    };

    Promo.prototype.togglePromo = function() {
      $('html').toggleClass("noscroll");
      return this.$el.find('[data-promo-overlay]').toggleClass('overlay--show');
    };

    return Promo;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Register = (function(superClass) {
    extend(Register, superClass);

    function Register() {
      return Register.__super__.constructor.apply(this, arguments);
    }

    Register.prototype.events = {
      'submit form': 'triggerSubmit'
    };

    Register.prototype.triggerSubmit = function(e) {
      return window.localStorage.setItem('form-submit', 'register');
    };

    return Register;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Related = (function(superClass) {
    extend(Related, superClass);

    function Related() {
      return Related.__super__.constructor.apply(this, arguments);
    }

    Related.prototype.num = 3;

    Related.prototype.initialize = function() {
      return this.reorganize();
    };

    Related.prototype.reorganize = function() {
      var count, randIndex, self;
      self = this;
      count = 0;
      if (this.$el.find('.col--product:not(.keep)').length > this.num) {
        while (count < this.num) {
          randIndex = Math.floor(Math.random() * this.$el.find('.col--product:not(.keep)').length);
          this.$el.find('.col--product:not(.keep)').eq(randIndex).addClass('keep');
          count++;
        }
        this.$el.find('.col--product:not(.keep)').remove();
      }
      return this.$el.removeClass('hide');
    };

    return Related;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Search = (function(superClass) {
    extend(Search, superClass);

    function Search() {
      return Search.__super__.constructor.apply(this, arguments);
    }

    Search.prototype.el = $("#search");

    Search.prototype.data = {};

    Search.prototype.events = {
      "click [data-hide]": "hide"
    };

    Search.prototype.initialize = function() {
      this.render();
      return this.bindEvents();
    };

    Search.prototype.render = function() {
      return this;
    };

    Search.prototype.bindEvents = function() {
      return $(document).keyup((function(_this) {
        return function(e) {
          if (e.keyCode === 27) {
            return _this.hide(e);
          }
        };
      })(this));
    };

    Search.prototype.toggle = function(e) {
      if (this.$el.hasClass("overlay--show")) {
        return this.hide(e);
      } else {
        return this.show(e);
      }
    };

    Search.prototype.show = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.addClass("overlay--show");
      $('body').addClass('body--freeze');
      $('body').addClass('show--search');
      return this.$el.find("[type='search']").focus();
    };

    Search.prototype.hide = function(e) {
      if (e != null) {
        e.preventDefault();
      }
      this.$el.removeClass("overlay--show");
      $('body').removeClass('body--freeze');
      return $('body').removeClass('show--search');
    };

    return Search;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.Sections = (function(superClass) {
    extend(Sections, superClass);

    function Sections() {
      return Sections.__super__.constructor.apply(this, arguments);
    }

    Sections.prototype.events = {
      "click [data-toggle-section]": "toggleSection"
    };

    Sections.prototype.toggleSection = function(e) {
      var level, section;
      e.preventDefault();
      section = $(e.currentTarget).data('toggle-section');
      if ($(e.currentTarget).data('level') != null) {
        level = $(e.currentTarget).data('level');
      }
      if (level && level > 1) {
        this.$el.find('[data-section][data-level="' + level + '"]').addClass('hide');
        this.$el.find('[data-toggle-section][data-level="' + level + '"]').removeClass('active');
      } else {
        this.$el.find('[data-section]').addClass('hide');
        this.$el.find('[data-toggle-section]').removeClass('active');
      }
      this.$el.find('[data-section="' + section + '"]').removeClass('hide');
      $(e.currentTarget).addClass('active');
      if ($(e.currentTarget).hasClass('edit-ib')) {
        $('html, body').animate({
          scrollTop: $('#scroll_test').offset().top
        }, 800);
      }
      if (this.$el.find('[data-section="' + section + '"] [data-carousel]').length) {
        this.$el.find('[data-section="' + section + '"]').addClass('invisible');
        this.$el.find('[data-section="' + section + '"] [data-carousel]').slick('refresh');
        return setTimeout((function(_this) {
          return function() {
            return _this.$el.find('[data-section="' + section + '"]').removeClass('invisible');
          };
        })(this), 50);
      }
    };

    return Sections;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.StaticPage = (function(superClass) {
    extend(StaticPage, superClass);

    function StaticPage() {
      return StaticPage.__super__.constructor.apply(this, arguments);
    }

    StaticPage.prototype.initialize = function() {
      this.$images = this.$el.find('[data-carousel-image]');
      if (this.$images.length) {
        this.createCarousel();
        this.appendImages();
        return this.initializeCarousel();
      }
    };

    StaticPage.prototype.createCarousel = function() {
      var carousel, dataCarousel, section, title;
      section = document.createElement('section');
      section.className = 'text_center';
      $(section).insertAfter(this.$images.first());
      title = document.createElement('h2');
      title.className = 'medium_bottom';
      section.appendChild(title);
      $(title).html(this.$el.data('carousel-title'));
      carousel = document.createElement('div');
      dataCarousel = document.createAttribute('data-carousel');
      carousel.className = 'slick-slider--guttered';
      carousel.setAttributeNode(dataCarousel);
      this.$carousel = $(carousel);
      return section.appendChild(carousel);
    };

    StaticPage.prototype.appendImages = function() {
      var self;
      self = this;
      return this.$images.each(function() {
        return self.$carousel.append($(this));
      });
    };

    StaticPage.prototype.initializeCarousel = function() {
      return this.$carousel.slick({
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '100px',
        infinite: true,
        arrows: true,
        draggable: false,
        prevArrow: '<span class="slick-prev slick-arrow--light"><svg class="icon"><use xlink:href="#icon-left"></use></svg></span>',
        nextArrow: '<span class="slick-next slick-arrow--light"><svg class="icon"><use xlink:href="#icon-right"></use></svg></span>',
        responsive: [
          {
            breakpoint: 900,
            settings: {
              arrows: false,
              infinite: true,
              dots: true,
              draggable: true,
              dotsClass: 'slick-dots slick-dots--light'
            }
          }
        ]
      });
    };

    return StaticPage;

  })(Backbone.View);

}).call(this);

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Rubino.Views.SubscriptionPromo = (function(superClass) {
    extend(SubscriptionPromo, superClass);

    function SubscriptionPromo() {
      return SubscriptionPromo.__super__.constructor.apply(this, arguments);
    }

    SubscriptionPromo.prototype.id = null;

    SubscriptionPromo.prototype.events = {
      "click [data-promo-hide]": "hidePromo",
      "click [data-promo-toggle]": "togglePromo"
    };

    SubscriptionPromo.prototype.initialize = function() {
      this.id = this.$el.data('subscription-promo');
      return this.days = this.$el.data('days');
    };

    SubscriptionPromo.prototype.hidePromo = function() {
      $('html').removeClass("noscroll");
      return this.$el.find('[data-promo-overlay]').removeClass('overlay--show');
    };

    SubscriptionPromo.prototype.showPromo = function() {
      if (Rubino.cookies.get("subscription_promo_hidden--" + this.id) == null) {
        $('html').addClass("noscroll");
        this.$el.find('[data-promo-overlay]').addClass('overlay--show');
        if (this.days > 0) {
          return Rubino.cookies.set("subscription_promo_hidden--" + this.id, true, this.days);
        }
      }
    };

    SubscriptionPromo.prototype.togglePromo = function() {
      $('html').toggleClass("noscroll");
      return this.$el.find('[data-promo-overlay]').toggleClass('overlay--show');
    };

    return SubscriptionPromo;

  })(Backbone.View);

}).call(this);
